
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.16.1
 * Query Engine version: b20ead4d3ab9e78ac112966e242ded703f4a052c
 */
Prisma.prismaVersion = {
  client: "4.16.1",
  engine: "b20ead4d3ab9e78ac112966e242ded703f4a052c"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserProfileRoleScalarFieldEnum = {
  userProfileId: 'userProfileId',
  roleId: 'roleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SuperUserRoleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SuperUserProfileRoleScalarFieldEnum = {
  userProfileId: 'userProfileId',
  superUserRoleId: 'superUserRoleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PermissionScalarFieldEnum = {
  id: 'id',
  customerType: 'customerType',
  roleId: 'roleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  superUserRoleId: 'superUserRoleId'
};

exports.Prisma.ResolverScalarFieldEnum = {
  id: 'id',
  name: 'name',
  userProfileId: 'userProfileId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PermissionResolverScalarFieldEnum = {
  permissionId: 'permissionId',
  resolverId: 'resolverId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FeatureScalarFieldEnum = {
  id: 'id',
  name: 'name',
  parentId: 'parentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserProfileFeatureScalarFieldEnum = {
  userProfileId: 'userProfileId',
  featureId: 'featureId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserProfileResolverScalarFieldEnum = {
  userProfileId: 'userProfileId',
  resolverId: 'resolverId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PermissionFeatureScalarFieldEnum = {
  permissionId: 'permissionId',
  featureId: 'featureId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdditionalUserDetailScalarFieldEnum = {
  id: 'id',
  ssn: 'ssn',
  businessId: 'businessId',
  stripeCustomerId: 'stripeCustomerId',
  highNoteApplicationId: 'highNoteApplicationId',
  paymentSource: 'paymentSource',
  highRisk: 'highRisk',
  highRiskDescription: 'highRiskDescription',
  isBetaTester: 'isBetaTester',
  delinquency: 'delinquency',
  isDefault: 'isDefault',
  customerTier: 'customerTier',
  customerSupportAdminId: 'customerSupportAdminId',
  userDepositCode: 'userDepositCode',
  depositAmount: 'depositAmount',
  depositDate: 'depositDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userProfileId: 'userProfileId',
  developerAuthorizationBearer: 'developerAuthorizationBearer',
  developerAuthorizationBearerCreatedAt: 'developerAuthorizationBearerCreatedAt'
};

exports.Prisma.UserProfileScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  otherUserDetailId: 'otherUserDetailId',
  userLeadId: 'userLeadId',
  email: 'email',
  phoneNumber: 'phoneNumber',
  bypassOtpDuringLogIn: 'bypassOtpDuringLogIn',
  phoneLastDateOfEdit: 'phoneLastDateOfEdit',
  emailLastDateOfEdit: 'emailLastDateOfEdit',
  isEmailVerified: 'isEmailVerified',
  isPhoneVerified: 'isPhoneVerified',
  isLoggedIn: 'isLoggedIn',
  firstName: 'firstName',
  lastName: 'lastName',
  passwordHash: 'passwordHash',
  passwordSalt: 'passwordSalt',
  passwordResetToken: 'passwordResetToken',
  passwordResetTokenCreatedAt: 'passwordResetTokenCreatedAt',
  newEmail: 'newEmail',
  emailVerificationHash: 'emailVerificationHash',
  emailVerificationHashCreatedAt: 'emailVerificationHashCreatedAt',
  executiveJobTitle: 'executiveJobTitle',
  dateOfBirth: 'dateOfBirth',
  parentId: 'parentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  permissionId: 'permissionId',
  accountDisplaySettingId: 'accountDisplaySettingId',
  isParentCompanyUser: 'isParentCompanyUser',
  parentCompanyUserAuthorizedProfileId: 'parentCompanyUserAuthorizedProfileId',
  isParentCompanyImpersonator: 'isParentCompanyImpersonator',
  highNoteApplicationId: 'highNoteApplicationId'
};

exports.Prisma.UserTransactionsFileExportTemplateScalarFieldEnum = {
  id: 'id',
  userProfileId: 'userProfileId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  templateName: 'templateName',
  fields: 'fields',
  templateType: 'templateType'
};

exports.Prisma.AccountDisplaySettingScalarFieldEnum = {
  id: 'id',
  userProfileId: 'userProfileId',
  timeZone: 'timeZone',
  colorScheme: 'colorScheme',
  showCompanyName: 'showCompanyName'
};

exports.Prisma.AzureExternalUserInvitationScalarFieldEnum = {
  id: 'id',
  userProfileId: 'userProfileId',
  invitationStatus: 'invitationStatus',
  azureId: 'azureId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.AccountControlSettingsScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  dynamicPurchaseControlsLinkedTo: 'dynamicPurchaseControlsLinkedTo',
  cardSharingControl: 'cardSharingControl',
  preauthorizationText: 'preauthorizationText',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ParameterFilterScalarFieldEnum = {
  id: 'id',
  tag: 'tag',
  readWritePermission: 'readWritePermission',
  otherUserDetailId: 'otherUserDetailId'
};

exports.Prisma.OtherUserDetailScalarFieldEnum = {
  id: 'id',
  userProfileId: 'userProfileId',
  status: 'status',
  createdAt: 'createdAt'
};

exports.Prisma.ProductsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AlertsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  read: 'read',
  message: 'message',
  type: 'type',
  additionalUserDetailId: 'additionalUserDetailId',
  deleted: 'deleted'
};

exports.Prisma.PreauthorizeTransactionAlertsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  preauthorizeTransactionTimeStamp: 'preauthorizeTransactionTimeStamp',
  preauthorizeTransactionDetails: 'preauthorizeTransactionDetails',
  preauthorizeTransactionStatus: 'preauthorizeTransactionStatus',
  additionalUserDetailId: 'additionalUserDetailId',
  cardId: 'cardId',
  deleted: 'deleted'
};

exports.Prisma.DriverAlertsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  read: 'read',
  message: 'message',
  type: 'type',
  fleetDriverId: 'fleetDriverId',
  deleted: 'deleted'
};

exports.Prisma.UserProductStatusScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  productId: 'productId',
  status: 'status',
  message: 'message',
  onBoardStatus: 'onBoardStatus',
  marketingMessageSentAt: 'marketingMessageSentAt',
  statusUpdatedAt: 'statusUpdatedAt',
  approvedAt: 'approvedAt',
  submittedAt: 'submittedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuickBooksDetailScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  realmId: 'realmId',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  accessTokenExpDt: 'accessTokenExpDt',
  refreshTokenExpDt: 'refreshTokenExpDt',
  isAuthenticated: 'isAuthenticated',
  lastSyncedAt: 'lastSyncedAt',
  isPastTransactionsSynced: 'isPastTransactionsSynced',
  shouldSyncPast: 'shouldSyncPast',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AddressUsageScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  type: 'type',
  streetAddress: 'streetAddress',
  streetDetails: 'streetDetails',
  state: 'state',
  city: 'city',
  zip: 'zip',
  isPrimary: 'isPrimary',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BusinessScalarFieldEnum = {
  id: 'id',
  title: 'title',
  cardName: 'cardName',
  description: 'description',
  additionalUserDetailId: 'additionalUserDetailId',
  type: 'type',
  companyType: 'companyType',
  deliveryType: 'deliveryType',
  paymentMethodType: 'paymentMethodType',
  dot: 'dot',
  ein: 'ein',
  yearsOfOperation: 'yearsOfOperation',
  annualBusinessRevenue: 'annualBusinessRevenue',
  mc: 'mc',
  isApplicationSent: 'isApplicationSent',
  applicationStatus: 'applicationStatus',
  collectionAdminId: 'collectionAdminId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CardPaymentMethodScalarFieldEnum = {
  id: 'id',
  paymentMethodId: 'paymentMethodId',
  deletedAt: 'deletedAt',
  addedAt: 'addedAt',
  updatedAt: 'updatedAt',
  businessId: 'businessId'
};

exports.Prisma.FleetInfoScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  fuel: 'fuel',
  fleetNum: 'fleetNum',
  fleetType: 'fleetType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountDocumentsScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName',
  fileType: 'fileType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  metaData: 'metaData',
  published: 'published',
  deleted: 'deleted'
};

exports.Prisma.StatementCustomizationSettingScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  categorization: 'categorization',
  columns: 'columns',
  showDetailedBreakdown: 'showDetailedBreakdown',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FactorDocumentScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  w9form: 'w9form',
  insuranceCert: 'insuranceCert',
  articlesIncorporation: 'articlesIncorporation',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PlaidConnectScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  userLeadId: 'userLeadId',
  institution: 'institution',
  itemId: 'itemId',
  accessToken: 'accessToken',
  isAutomatePayment: 'isAutomatePayment',
  mtExternalAccountId: 'mtExternalAccountId',
  accountType: 'accountType',
  plaidError: 'plaidError',
  newAccountsAvailable: 'newAccountsAvailable',
  authInfo: 'authInfo',
  transactions: 'transactions',
  accountInfo: 'accountInfo',
  stripeBankAccount: 'stripeBankAccount',
  processorToken: 'processorToken',
  isPrimary: 'isPrimary',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PlaidConnectPendingScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  accessToken: 'accessToken',
  institution: 'institution',
  itemId: 'itemId'
};

exports.Prisma.UserWalletScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  signOnBalance: 'signOnBalance',
  referralBalance: 'referralBalance',
  cashBalance: 'cashBalance',
  adminBalance: 'adminBalance',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserWalletItemsScalarFieldEnum = {
  id: 'id',
  walletId: 'walletId',
  paymentId: 'paymentId',
  billingCycleId: 'billingCycleId',
  type: 'type',
  signOnBalanceFlow: 'signOnBalanceFlow',
  referralBalanceFlow: 'referralBalanceFlow',
  cashBalanceFlow: 'cashBalanceFlow',
  adminBalanceFlow: 'adminBalanceFlow',
  ItemType: 'ItemType',
  amount: 'amount',
  details: 'details',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  authorizationId: 'authorizationId',
  transactionId: 'transactionId',
  classification: 'classification',
  balanceHistory: 'balanceHistory',
  balanceHistoryUpdatedAt: 'balanceHistoryUpdatedAt',
  fuelDiscountAmount: 'fuelDiscountAmount',
  oldTransactionId: 'oldTransactionId'
};

exports.Prisma.DefaultSettingScalarFieldEnum = {
  id: 'id',
  creditCycleType: 'creditCycleType',
  creditLimit: 'creditLimit',
  numberOfCards: 'numberOfCards',
  customerType: 'customerType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CardHoldersMembershipScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  cardHolderId: 'cardHolderId',
  counterPartyId: 'counterPartyId',
  status: 'status',
  carHolderType: 'carHolderType',
  activeFlag: 'activeFlag',
  allowCategories: 'allowCategories',
  restrictCategories: 'restrictCategories',
  whitelistMerchant: 'whitelistMerchant',
  blockMerchant: 'blockMerchant',
  allowMerchant: 'allowMerchant',
  allowedMerchantsNetworkIds: 'allowedMerchantsNetworkIds',
  blockedMerchantsNetworkIds: 'blockedMerchantsNetworkIds',
  blockState: 'blockState',
  currency: 'currency',
  stripeResponse: 'stripeResponse',
  ACHAttempt: 'ACHAttempt',
  amountCorrection: 'amountCorrection',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  numberOfCardsCharged: 'numberOfCardsCharged',
  lastUpdateDate: 'lastUpdateDate',
  additionalCategory: 'additionalCategory',
  highNoteFinancialAccId: 'highNoteFinancialAccId',
  highNoteResponse: 'highNoteResponse'
};

exports.Prisma.CronInfoScalarFieldEnum = {
  id: 'id',
  name: 'name',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CardScalarFieldEnum = {
  id: 'id',
  cardHolderId: 'cardHolderId',
  additionalUserDetailId: 'additionalUserDetailId',
  type: 'type',
  currency: 'currency',
  metaData: 'metaData',
  cardType: 'cardType',
  cardId: 'cardId',
  brand: 'brand',
  lastFour: 'lastFour',
  expiryMonth: 'expiryMonth',
  expiryYear: 'expiryYear',
  livemode: 'livemode',
  status: 'status',
  blockState: 'blockState',
  countries: 'countries',
  stripeResponse: 'stripeResponse',
  authorizationMethod: 'authorizationMethod',
  activationDate: 'activationDate',
  smsSecurity: 'smsSecurity',
  telematicsSecurity: 'telematicsSecurity',
  fuelTypeSecurity: 'fuelTypeSecurity',
  tankCapacitySecurity: 'tankCapacitySecurity',
  odometerSecurity: 'odometerSecurity',
  suspiciousFuelingSecurity: 'suspiciousFuelingSecurity',
  preauthorizeTransactionUnlock: 'preauthorizeTransactionUnlock',
  enableSmsReceiptUpload: 'enableSmsReceiptUpload',
  enableOperationalHours: 'enableOperationalHours',
  requireJobID: 'requireJobID',
  flaggedMerchantCategories: 'flaggedMerchantCategories',
  dynamicPurchaseControlsSetting: 'dynamicPurchaseControlsSetting',
  dynamicPurchaseControlsAllowedFuelCategories: 'dynamicPurchaseControlsAllowedFuelCategories',
  dynamicPurchaseControlsAllowedNonFuelCategories: 'dynamicPurchaseControlsAllowedNonFuelCategories',
  cardUnlockStep: 'cardUnlockStep',
  cardUnlockStepTime: 'cardUnlockStepTime',
  genericIdPromptMode: 'genericIdPromptMode',
  genericIdPromptEntityType: 'genericIdPromptEntityType',
  blockedMerchantsNetworkIds: 'blockedMerchantsNetworkIds',
  allowedMerchantsNetworkIds: 'allowedMerchantsNetworkIds',
  platform: 'platform',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deleted: 'deleted',
  cardSharingControls: 'cardSharingControls',
  stripeCardProgram: 'stripeCardProgram'
};

exports.Prisma.CardMerchantsScalarFieldEnum = {
  id: 'id',
  authorized: 'authorized',
  classification: 'classification',
  toggleOn: 'toggleOn',
  cardId: 'cardId',
  cardRuleId: 'cardRuleId',
  name: 'name',
  numberOfPurchaseLimitToggleOn: 'numberOfPurchaseLimitToggleOn',
  numberOfPurchaseLimit: 'numberOfPurchaseLimit',
  numberOfPurchaseFrequency: 'numberOfPurchaseFrequency',
  totalSpendLimitToggleOn: 'totalSpendLimitToggleOn',
  totalSpendLimit: 'totalSpendLimit',
  totalSpendFrequency: 'totalSpendFrequency',
  requireMemo: 'requireMemo',
  requireReceiptAmount: 'requireReceiptAmount',
  requireReceiptToggleOn: 'requireReceiptToggleOn',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OperationalHoursScalarFieldEnum = {
  id: 'id',
  dayOfWeek: 'dayOfWeek',
  startTime: 'startTime',
  endTime: 'endTime',
  cardId: 'cardId',
  cardRuleId: 'cardRuleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CardRuleScalarFieldEnum = {
  id: 'id',
  cardHolderId: 'cardHolderId',
  name: 'name',
  description: 'description',
  enableOperationalHours: 'enableOperationalHours',
  blockState: 'blockState',
  countries: 'countries',
  smsSecurity: 'smsSecurity',
  telematicsSecurity: 'telematicsSecurity',
  fuelTypeSecurity: 'fuelTypeSecurity',
  tankCapacitySecurity: 'tankCapacitySecurity',
  odometerSecurity: 'odometerSecurity',
  requireJobID: 'requireJobID',
  enableSmsReceiptUpload: 'enableSmsReceiptUpload',
  preauthorizeTransactionUnlock: 'preauthorizeTransactionUnlock',
  suspiciousFuelingSecurity: 'suspiciousFuelingSecurity',
  flaggedMerchantCategories: 'flaggedMerchantCategories',
  authorizationMethod: 'authorizationMethod',
  genericIdPromptMode: 'genericIdPromptMode',
  genericIdPromptEntityType: 'genericIdPromptEntityType',
  dynamicPurchaseControlsSetting: 'dynamicPurchaseControlsSetting',
  dynamicPurchaseControlsAllowedFuelCategories: 'dynamicPurchaseControlsAllowedFuelCategories',
  dynamicPurchaseControlsAllowedNonFuelCategories: 'dynamicPurchaseControlsAllowedNonFuelCategories',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  cardSharingControls: 'cardSharingControls'
};

exports.Prisma.FleetDriverScalarFieldEnum = {
  id: 'id',
  promptCode: 'promptCode',
  additionalUserDetailId: 'additionalUserDetailId',
  businessId: 'businessId',
  cardId: 'cardId',
  vehicleSharingcardId: 'vehicleSharingcardId',
  name: 'name',
  email: 'email',
  phoneNumber: 'phoneNumber',
  status: 'status',
  phoneLastDateOfEdit: 'phoneLastDateOfEdit',
  emailLastDateOfEdit: 'emailLastDateOfEdit',
  passwordHash: 'passwordHash',
  passwordSalt: 'passwordSalt',
  passwordResetToken: 'passwordResetToken',
  passwordResetTokenCreatedAt: 'passwordResetTokenCreatedAt',
  isEmailVerified: 'isEmailVerified',
  isPhoneVerified: 'isPhoneVerified',
  notes: 'notes',
  deviceTokens: 'deviceTokens',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FleetScalarFieldEnum = {
  id: 'id',
  promptCode: 'promptCode',
  additionalUserDetailId: 'additionalUserDetailId',
  businessId: 'businessId',
  cardId: 'cardId',
  driverSharingCardId: 'driverSharingCardId',
  fleetName: 'fleetName',
  vin: 'vin',
  fleetLicensePlate: 'fleetLicensePlate',
  tankCapacity: 'tankCapacity',
  fuelType: 'fuelType',
  make: 'make',
  model: 'model',
  year: 'year',
  provisionState: 'provisionState',
  status: 'status',
  isLinkedToFleetio: 'isLinkedToFleetio',
  fleetioVehicleId: 'fleetioVehicleId',
  isEjWardConnected: 'isEjWardConnected',
  ejWardVehicleId: 'ejWardVehicleId',
  metaData: 'metaData',
  odometer: 'odometer',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FleetOdometerReadingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fleetId: 'fleetId',
  odometerReading: 'odometerReading',
  eldOdometerReading: 'eldOdometerReading',
  eldOdometerReadingTime: 'eldOdometerReadingTime'
};

exports.Prisma.CardHolderSpendingScalarFieldEnum = {
  id: 'id',
  cardHolderId: 'cardHolderId',
  amount: 'amount',
  interval: 'interval',
  category: 'category',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CardReplacementScalarFieldEnum = {
  id: 'id',
  cardId: 'cardId',
  replacement_for: 'replacement_for',
  replacement_reason: 'replacement_reason',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CardSpendingScalarFieldEnum = {
  id: 'id',
  cardId: 'cardId',
  cardRuleId: 'cardRuleId',
  amount: 'amount',
  interval: 'interval',
  category: 'category',
  highNoteSpendRuleId: 'highNoteSpendRuleId',
  highNoteVelocityRuleId: 'highNoteVelocityRuleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CardShippingScalarFieldEnum = {
  id: 'id',
  cardId: 'cardId',
  cardGroupOrderId: 'cardGroupOrderId',
  deliveryName: 'deliveryName',
  deliveryService: 'deliveryService',
  type: 'type',
  deliveryPartner: 'deliveryPartner',
  trackingNumber: 'trackingNumber',
  trackingUrl: 'trackingUrl',
  shippingLogs: 'shippingLogs',
  deliveryType: 'deliveryType',
  deliveryStatus: 'deliveryStatus',
  eta: 'eta',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CardOrderScalarFieldEnum = {
  id: 'id',
  status: 'status',
  failedReason: 'failedReason',
  cancellationTime: 'cancellationTime',
  cancellableUntil: 'cancellableUntil',
  cardProfileId: 'cardProfileId',
  deliveryType: 'deliveryType',
  requireSignature: 'requireSignature',
  cardType: 'cardType',
  stripeCardProgram: 'stripeCardProgram',
  quantity: 'quantity',
  notes: 'notes',
  streetAddress: 'streetAddress',
  streetDetails: 'streetDetails',
  state: 'state',
  city: 'city',
  zip: 'zip',
  cardHolderId: 'cardHolderId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TransactionScalarFieldEnum = {
  id: 'id',
  highnoteTransactionId: 'highnoteTransactionId',
  authorizationDate: 'authorizationDate',
  transactionDate: 'transactionDate',
  transactionStatus: 'transactionStatus',
  transactionAmount: 'transactionAmount',
  fuelDiscountAmount: 'fuelDiscountAmount',
  merchantName: 'merchantName',
  driverName: 'driverName',
  merchantState: 'merchantState',
  merchantPostCd: 'merchantPostCd',
  merchantCountry: 'merchantCountry',
  flagged: 'flagged',
  accounted: 'accounted',
  flagReason: 'flagReason',
  stripeResponse: 'stripeResponse',
  highnoteResponse: 'highnoteResponse',
  purchaseDetails: 'purchaseDetails',
  highnotePurchaseDetails: 'highnotePurchaseDetails',
  fuelDiscountDetail: 'fuelDiscountDetail',
  fuelQuantity: 'fuelQuantity',
  cardId: 'cardId',
  cardHolderId: 'cardHolderId',
  driverId: 'driverId',
  vehicleName: 'vehicleName',
  vehicleVIN: 'vehicleVIN',
  authorizationId: 'authorizationId',
  transactionType: 'transactionType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  memo: 'memo',
  fleetId: 'fleetId',
  extraInfo: 'extraInfo',
  transactionReceiptRequired: 'transactionReceiptRequired',
  cardRuleId: 'cardRuleId'
};

exports.Prisma.AccountTagScalarFieldEnum = {
  id: 'id',
  promptCode: 'promptCode',
  additionalUserDetailId: 'additionalUserDetailId',
  parentId: 'parentId',
  tagType: 'tagType',
  tagId: 'tagId',
  title: 'title',
  description: 'description',
  colorCode: 'colorCode',
  deleted: 'deleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CardAccountTagScalarFieldEnum = {
  id: 'id',
  cardId: 'cardId',
  accountTagId: 'accountTagId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FleetAccountTagScalarFieldEnum = {
  id: 'id',
  fleetId: 'fleetId',
  accountTagId: 'accountTagId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FleetDriverAccountTagScalarFieldEnum = {
  id: 'id',
  fleetDriverId: 'fleetDriverId',
  accountTagId: 'accountTagId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TransactionAccountTagScalarFieldEnum = {
  id: 'id',
  transactionId: 'transactionId',
  accountTagId: 'accountTagId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OldTransactionAccountTagScalarFieldEnum = {
  id: 'id',
  oldTransactionId: 'oldTransactionId',
  accountTagId: 'accountTagId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AuthorizationAccountTagScalarFieldEnum = {
  id: 'id',
  authorizationId: 'authorizationId',
  accountTagId: 'accountTagId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OldTransactionScalarFieldEnum = {
  id: 'id',
  highnoteTransactionId: 'highnoteTransactionId',
  authorizationDate: 'authorizationDate',
  transactionDate: 'transactionDate',
  transactionStatus: 'transactionStatus',
  transactionAmount: 'transactionAmount',
  fuelDiscountAmount: 'fuelDiscountAmount',
  merchantName: 'merchantName',
  driverName: 'driverName',
  merchantState: 'merchantState',
  merchantPostCd: 'merchantPostCd',
  merchantCountry: 'merchantCountry',
  flagged: 'flagged',
  accounted: 'accounted',
  flagReason: 'flagReason',
  stripeResponse: 'stripeResponse',
  highnoteResponse: 'highnoteResponse',
  purchaseDetails: 'purchaseDetails',
  highnotePurchaseDetails: 'highnotePurchaseDetails',
  fuelDiscountDetail: 'fuelDiscountDetail',
  fuelQuantity: 'fuelQuantity',
  cardId: 'cardId',
  cardHolderId: 'cardHolderId',
  driverId: 'driverId',
  vehicleName: 'vehicleName',
  vehicleVIN: 'vehicleVIN',
  authorizationId: 'authorizationId',
  transactionType: 'transactionType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  memo: 'memo',
  fleetId: 'fleetId',
  extraInfo: 'extraInfo',
  transactionReceiptRequired: 'transactionReceiptRequired',
  userWalletItemsId: 'userWalletItemsId',
  migratedAt: 'migratedAt',
  cardRuleId: 'cardRuleId'
};

exports.Prisma.ImportedTransactionScalarFieldEnum = {
  id: 'id',
  authorizationDate: 'authorizationDate',
  transactionDate: 'transactionDate',
  transactionStatus: 'transactionStatus',
  transactionAmount: 'transactionAmount',
  fuelDiscountAmount: 'fuelDiscountAmount',
  merchantName: 'merchantName',
  driverName: 'driverName',
  merchantState: 'merchantState',
  merchantPostCd: 'merchantPostCd',
  flagged: 'flagged',
  accounted: 'accounted',
  flagReason: 'flagReason',
  stripeResponse: 'stripeResponse',
  highnoteResponse: 'highnoteResponse',
  purchaseDetails: 'purchaseDetails',
  highnotePurchaseDetails: 'highnotePurchaseDetails',
  fuelDiscountDetail: 'fuelDiscountDetail',
  fuelQuantity: 'fuelQuantity',
  cardHolderId: 'cardHolderId',
  vehicleName: 'vehicleName',
  vehicleVIN: 'vehicleVIN',
  transactionType: 'transactionType',
  memo: 'memo',
  extraInfo: 'extraInfo',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TransactionReceiptScalarFieldEnum = {
  id: 'id',
  txnId: 'txnId',
  authzId: 'authzId',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OldTransactionReceiptScalarFieldEnum = {
  id: 'id',
  txnId: 'txnId',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AuthorizationScalarFieldEnum = {
  id: 'id',
  authorizationDate: 'authorizationDate',
  highnoteTransactionId: 'highnoteTransactionId',
  authorizationStatus: 'authorizationStatus',
  includeInFuelTheftSavings: 'includeInFuelTheftSavings',
  approvalStatus: 'approvalStatus',
  authorizationAmount: 'authorizationAmount',
  declineReason: 'declineReason',
  declineReasonDetails: 'declineReasonDetails',
  merchantName: 'merchantName',
  merchantState: 'merchantState',
  merchantPostCd: 'merchantPostCd',
  merchantCountry: 'merchantCountry',
  merchantCategory: 'merchantCategory',
  stripeResponse: 'stripeResponse',
  highnoteResponse: 'highnoteResponse',
  cardId: 'cardId',
  cardHolderId: 'cardHolderId',
  driverName: 'driverName',
  driverId: 'driverId',
  vehicleName: 'vehicleName',
  vehicleId: 'vehicleId',
  vehicleVIN: 'vehicleVIN',
  extraInfo: 'extraInfo',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  memo: 'memo',
  cardRuleId: 'cardRuleId'
};

exports.Prisma.BillingCycleScalarFieldEnum = {
  id: 'id',
  cardHolderId: 'cardHolderId',
  status: 'status',
  totalAmount: 'totalAmount',
  totalDiscount: 'totalDiscount',
  lateFees: 'lateFees',
  signOnUsage: 'signOnUsage',
  referralUsage: 'referralUsage',
  cashUsage: 'cashUsage',
  adminCashUsage: 'adminCashUsage',
  lateFeesDaysOverdue: 'lateFeesDaysOverdue',
  startDt: 'startDt',
  endDt: 'endDt',
  totalFuelQuantity: 'totalFuelQuantity',
  isSentToQuickbooks: 'isSentToQuickbooks',
  dueDate: 'dueDate',
  invoiceId: 'invoiceId',
  paymentTerms: 'paymentTerms',
  createdManually: 'createdManually',
  archive: 'archive',
  metaData: 'metaData',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BillingCycleItemsScalarFieldEnum = {
  id: 'id',
  itemName: 'itemName',
  itemAmount: 'itemAmount',
  order: 'order',
  billingCycleId: 'billingCycleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentHistoryScalarFieldEnum = {
  id: 'id',
  payId: 'payId',
  accountId: 'accountId',
  cardHolderId: 'cardHolderId',
  repaymentId: 'repaymentId',
  billingCycleId: 'billingCycleId',
  amount: 'amount',
  status: 'status',
  paymentType: 'paymentType',
  modernTreasuryStatus: 'modernTreasuryStatus',
  failureReason: 'failureReason',
  stripeResponse: 'stripeResponse',
  mtResponse: 'mtResponse',
  creditLimitRechargeTransaction: 'creditLimitRechargeTransaction',
  creditLimitRechargeTransactionAccounted: 'creditLimitRechargeTransactionAccounted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ManualPaymentHistoryScalarFieldEnum = {
  id: 'id',
  payIntentId: 'payIntentId',
  chargeId: 'chargeId',
  cardHolderId: 'cardHolderId',
  amount: 'amount',
  status: 'status',
  failureReason: 'failureReason',
  paymentType: 'paymentType',
  stripeResponse: 'stripeResponse',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  metaData: 'metaData'
};

exports.Prisma.RefundPaymentsScalarFieldEnum = {
  id: 'id',
  refundId: 'refundId',
  chargeId: 'chargeId',
  paymentId: 'paymentId',
  manualPaymentHistoryId: 'manualPaymentHistoryId',
  cardHolderId: 'cardHolderId',
  amount: 'amount',
  status: 'status',
  stripeReason: 'stripeReason',
  stripeResponse: 'stripeResponse',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DisputePaymentsScalarFieldEnum = {
  id: 'id',
  disputeId: 'disputeId',
  chargeId: 'chargeId',
  cardHolderId: 'cardHolderId',
  paymentId: 'paymentId',
  manualPaymentHistoryId: 'manualPaymentHistoryId',
  amount: 'amount',
  status: 'status',
  reason: 'reason',
  evidence: 'evidence',
  stripeResponse: 'stripeResponse',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserSignUpBonusScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  bonusType: 'bonusType',
  bonusAmount: 'bonusAmount',
  fuelQuantity: 'fuelQuantity',
  eligibleDate: 'eligibleDate',
  isEligible: 'isEligible',
  isPaid: 'isPaid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserLendFlowDataScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  applicationId: 'applicationId',
  driverLicenceJson: 'driverLicenceJson',
  applicationJson: 'applicationJson',
  status: 'status',
  flagStatus: 'flagStatus',
  ekata: 'ekata',
  experianUccs: 'experianUccs',
  experianBankruptcies: 'experianBankruptcies',
  experianJudgments: 'experianJudgments',
  experianLiens: 'experianLiens',
  experianIntelliscore: 'experianIntelliscore',
  experianFsr: 'experianFsr',
  dnbFiL4: 'dnbFiL4',
  middesk: 'middesk',
  ocrolusCfa: 'ocrolusCfa',
  documentVerification: 'documentVerification',
  message: 'message',
  receivedFromWebhookAt: 'receivedFromWebhookAt',
  lendFlowProductState: 'lendFlowProductState',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UnderwritingDataScalarFieldEnum = {
  id: 'id',
  userLendFlowId: 'userLendFlowId',
  applicationId: 'applicationId',
  isLicenseVerified: 'isLicenseVerified',
  isBusinessNameVerified: 'isBusinessNameVerified',
  isPeopleVerified: 'isPeopleVerified',
  isOfficeAddressVerified: 'isOfficeAddressVerified',
  sosActivationStatus: 'sosActivationStatus',
  sosDomesticActivationStatus: 'sosDomesticActivationStatus',
  isTinMatch: 'isTinMatch',
  watchListHitCount: 'watchListHitCount',
  registrationStatus: 'registrationStatus',
  transactionRiskScore: 'transactionRiskScore',
  accountOpeningRiskScore: 'accountOpeningRiskScore',
  addressRiskScore: 'addressRiskScore',
  isPhoneRisk: 'isPhoneRisk',
  recommendedCreditLimit: 'recommendedCreditLimit',
  intelliscoreRiskClass: 'intelliscoreRiskClass',
  fsrRiskCalss: 'fsrRiskCalss',
  bankruptcyCount: 'bankruptcyCount',
  judgementCount: 'judgementCount',
  uccFilingCount: 'uccFilingCount',
  lienCount: 'lienCount',
  avgEstimatedRevenue: 'avgEstimatedRevenue',
  avgDailyBalance: 'avgDailyBalance',
  negativeBalanceCount: 'negativeBalanceCount',
  nsfCount: 'nsfCount',
  altLendingDebitValue: 'altLendingDebitValue',
  altLendingDebitCount: 'altLendingDebitCount',
  netCashFlowSum: 'netCashFlowSum',
  autoUnderwritingEligible: 'autoUnderwritingEligible',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminUnderwritingSettingScalarFieldEnum = {
  id: 'id',
  suitableApplication: 'suitableApplication',
  kyc: 'kyc',
  kyb: 'kyb',
  businessCredit: 'businessCredit',
  ocrolus: 'ocrolus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  identifier: 'identifier',
  email: 'email',
  roles: 'roles',
  passwordHash: 'passwordHash',
  passwordSalt: 'passwordSalt',
  lastLogin: 'lastLogin',
  isLoggedIn: 'isLoggedIn',
  deleted: 'deleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminRoleScalarFieldEnum = {
  adminId: 'adminId',
  adminRoleMasterId: 'adminRoleMasterId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminRoleMasterScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminPermissionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  pageNames: 'pageNames',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminPermissionRoleMasterScalarFieldEnum = {
  adminRoleMasterId: 'adminRoleMasterId',
  adminPermissionId: 'adminPermissionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  adminId: 'adminId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminFuelDiscountScalarFieldEnum = {
  id: 'id',
  fuelType: 'fuelType',
  customerType: 'customerType',
  fuelInGallons: 'fuelInGallons',
  fuelDiscount: 'fuelDiscount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminSignUpBonusScalarFieldEnum = {
  id: 'id',
  bonusType: 'bonusType',
  bonusAmount: 'bonusAmount',
  fuelQuantity: 'fuelQuantity',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminReferralBonusScalarFieldEnum = {
  id: 'id',
  bonusAmount: 'bonusAmount',
  bonusType: 'bonusType',
  fuelQuantity: 'fuelQuantity',
  days: 'days',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ReferralScalarFieldEnum = {
  id: 'id',
  referredBy: 'referredBy',
  referred: 'referred',
  additionalUserDetailId: 'additionalUserDetailId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ReferralCodeScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ReferralCreditScalarFieldEnum = {
  id: 'id',
  referredById: 'referredById',
  referralCode: 'referralCode',
  bonusAmount: 'bonusAmount',
  bonusType: 'bonusType',
  fuelQuantity: 'fuelQuantity',
  days: 'days',
  status: 'status',
  referralSetting: 'referralSetting',
  additionalUserDetailId: 'additionalUserDetailId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AffiliateReferralScalarFieldEnum = {
  id: 'id',
  affiliateCode: 'affiliateCode',
  email: 'email',
  referred: 'referred',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminEmailScalarFieldEnum = {
  id: 'id',
  email: 'email',
  password: 'password',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmailTemplatesScalarFieldEnum = {
  id: 'id',
  templateName: 'templateName',
  sendgridTemplateType: 'sendgridTemplateType',
  variables: 'variables',
  emailId: 'emailId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SendGridTemplatesScalarFieldEnum = {
  id: 'id',
  sendgridTemplateType: 'sendgridTemplateType',
  templateId: 'templateId',
  variableNames: 'variableNames'
};

exports.Prisma.SmsTemplatesScalarFieldEnum = {
  id: 'id',
  messageType: 'messageType',
  message: 'message'
};

exports.Prisma.MailTypeScalarFieldEnum = {
  id: 'id',
  mailType: 'mailType',
  templateName: 'templateName',
  monitor: 'monitor',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminCollectionsWorkflowSettingsScalarFieldEnum = {
  id: 'id',
  isEmailEnabled: 'isEmailEnabled',
  isSmsEnabled: 'isSmsEnabled'
};

exports.Prisma.AdminBlogsScalarFieldEnum = {
  id: 'id',
  title: 'title',
  blogUrlId: 'blogUrlId',
  summary: 'summary',
  rank: 'rank',
  publishDate: 'publishDate',
  blog: 'blog',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
};

exports.Prisma.AdminBlogImagesScalarFieldEnum = {
  id: 'id',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName',
  titleImage: 'titleImage',
  adminBlogId: 'adminBlogId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminInTheNewsScalarFieldEnum = {
  id: 'id',
  title: 'title',
  summary: 'summary',
  rank: 'rank',
  publishDate: 'publishDate',
  newsLink: 'newsLink',
  content: 'content',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
};

exports.Prisma.AdminCardSettingScalarFieldEnum = {
  id: 'id',
  dailyLimit: 'dailyLimit',
  transactionLimit: 'transactionLimit',
  minRepayLimit: 'minRepayLimit',
  categories: 'categories',
  oldCategories: 'oldCategories',
  customerType: 'customerType',
  restrictedMerchants: 'restrictedMerchants',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminApprovalSettingScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  creditCycleType: 'creditCycleType',
  previousCreditCyleType: 'previousCreditCyleType',
  updatedCreditLimit: 'updatedCreditLimit',
  creditLimit: 'creditLimit',
  additionalLimit: 'additionalLimit',
  adminOrderedCards: 'adminOrderedCards',
  numberOfCards: 'numberOfCards',
  customerType: 'customerType',
  platform: 'platform',
  metaData: 'metaData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ApproveAutoUnderwritingSettingScalarFieldEnum = {
  id: 'id',
  isLicenseVerified: 'isLicenseVerified',
  isBusinessNameVerified: 'isBusinessNameVerified',
  isPeopleVerified: 'isPeopleVerified',
  isOfficeAddressVerified: 'isOfficeAddressVerified',
  sosActivationStatus: 'sosActivationStatus',
  sosDomesticActivationStatus: 'sosDomesticActivationStatus',
  isTinMatch: 'isTinMatch',
  watchListHitCount: 'watchListHitCount',
  registrationStatus: 'registrationStatus',
  transactionRiskScore: 'transactionRiskScore',
  accountOpeningRiskScore: 'accountOpeningRiskScore',
  addressRiskScore: 'addressRiskScore',
  isPhoneRisk: 'isPhoneRisk',
  recommendedCreditLimit: 'recommendedCreditLimit',
  intelliscoreRiskClass: 'intelliscoreRiskClass',
  fsrRiskCalss: 'fsrRiskCalss',
  bankruptcyCount: 'bankruptcyCount',
  judgementCount: 'judgementCount',
  uccFilingCount: 'uccFilingCount',
  lienCount: 'lienCount',
  avgEstimatedRevenue: 'avgEstimatedRevenue',
  avgDailyBalance: 'avgDailyBalance',
  negativeBalanceCount: 'negativeBalanceCount',
  nsfCount: 'nsfCount',
  altLendingDebitValue: 'altLendingDebitValue',
  altLendingDebitCount: 'altLendingDebitCount',
  autoUnderWriting: 'autoUnderWriting',
  netCashFlowSum: 'netCashFlowSum',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RejectUnderwritingSettingScalarFieldEnum = {
  id: 'id',
  isTinMatch: 'isTinMatch',
  watchListHitCount: 'watchListHitCount',
  avgEstimatedRevenue: 'avgEstimatedRevenue',
  avgDailyBalance: 'avgDailyBalance',
  companyType: 'companyType',
  autoUnderWriting: 'autoUnderWriting',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminCommentsScalarFieldEnum = {
  id: 'id',
  adminId: 'adminId',
  adminFname: 'adminFname',
  adminLname: 'adminLname',
  comments: 'comments',
  type: 'type',
  pin: 'pin',
  additionalUserDetailId: 'additionalUserDetailId',
  userLeadId: 'userLeadId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminActivityLogScalarFieldEnum = {
  id: 'id',
  adminId: 'adminId',
  activityType: 'activityType',
  userLeadId: 'userLeadId',
  userProfileId: 'userProfileId',
  activity: 'activity',
  activityDetails: 'activityDetails',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserActivityLogScalarFieldEnum = {
  id: 'id',
  activityType: 'activityType',
  userProfileId: 'userProfileId',
  activity: 'activity',
  activityDetails: 'activityDetails',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LendflowProductSchemaScalarFieldEnum = {
  id: 'id',
  product: 'product',
  state: 'state',
  nextState: 'nextState',
  verificationObjects: 'verificationObjects',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EldDeviceInfoScalarFieldEnum = {
  id: 'id',
  orgName: 'orgName',
  additionalUserDetailId: 'additionalUserDetailId',
  credential: 'credential',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EldDeviceDetailsScalarFieldEnum = {
  id: 'id',
  deviceId: 'deviceId',
  deviceDetails: 'deviceDetails',
  fleetId: 'fleetId',
  eldDeviceInfoId: 'eldDeviceInfoId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EldDeviceMappingHistoryScalarFieldEnum = {
  id: 'id',
  deviceId: 'deviceId',
  fleetId: 'fleetId',
  orgName: 'orgName',
  additionalUserDetailId: 'additionalUserDetailId',
  isActive: 'isActive',
  lastMappedAt: 'lastMappedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmailWorkflowScalarFieldEnum = {
  id: 'id',
  day: 'day',
  notificationType: 'notificationType',
  emailId: 'emailId',
  emailTemplate: 'emailTemplate',
  emailTemplateSubject: 'emailTemplateSubject',
  sendgridTemplateType: 'sendgridTemplateType',
  variables: 'variables',
  smsTemplate: 'smsTemplate',
  workflowType: 'workflowType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BusinessUnderwritingProcessScalarFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  userLeadId: 'userLeadId',
  message: 'message',
  stage: 'stage',
  processingStage: 'processingStage',
  issues: 'issues',
  isResume: 'isResume',
  isEligibleForPrepaid: 'isEligibleForPrepaid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BusinessUnderwritingDataScalarFieldEnum = {
  id: 'id',
  businessUnderwritingProcessId: 'businessUnderwritingProcessId',
  dataType: 'dataType',
  subDataType: 'subDataType',
  externalId: 'externalId',
  data: 'data',
  status: 'status',
  dataStatus: 'dataStatus',
  message: 'message',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UnderwritingDataResultScalarFieldEnum = {
  id: 'id',
  businessUnderwritingProcessId: 'businessUnderwritingProcessId',
  autoUnderwritingEligible: 'autoUnderwritingEligible',
  data: 'data',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LedgerScalarFieldEnum = {
  id: 'id',
  name: 'name',
  normalBalance: 'normalBalance',
  metaData: 'metaData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LedgerTransactionScalarFieldEnum = {
  id: 'id',
  transactionType: 'transactionType',
  transactionDetail: 'transactionDetail',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LedgerEntriesScalarFieldEnum = {
  id: 'id',
  ledgerName: 'ledgerName',
  amount: 'amount',
  direction: 'direction',
  ledgerTransactionId: 'ledgerTransactionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminSystemHealthScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  type: 'type',
  data: 'data',
  order: 'order',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserFunctionalityTrackerByAdminScalarFieldEnum = {
  id: 'id',
  type: 'type',
  identifier: 'identifier',
  details: 'details',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RepaymentScalarFieldEnum = {
  id: 'id',
  cardHolderId: 'cardHolderId',
  amount: 'amount',
  status: 'status',
  durationInNumber: 'durationInNumber',
  repaymentDurationType: 'repaymentDurationType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmailHistoryScalarFieldEnum = {
  id: 'id',
  email: 'email',
  messageId: 'messageId',
  emailType: 'emailType',
  variables: 'variables',
  status: 'status',
  result: 'result',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LogFilesScalarFieldEnum = {
  id: 'id',
  month: 'month',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName',
  fileType: 'fileType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LateFeesTransactionScalarFieldEnum = {
  id: 'id',
  billingCycleId: 'billingCycleId',
  cardHolderId: 'cardHolderId',
  lateFeesAmount: 'lateFeesAmount',
  lateFeesType: 'lateFeesType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MonthlyCardFeeScalarFieldEnum = {
  id: 'id',
  customerType: 'customerType',
  amount: 'amount',
  effectiveFrom: 'effectiveFrom',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StripeDetailsScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  userLeadId: 'userLeadId',
  status: 'status',
  data: 'data',
  failureData: 'failureData',
  stripeAccountId: 'stripeAccountId',
  stripePersonId: 'stripePersonId',
  isCardHolderLinked: 'isCardHolderLinked',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AutoReloadSettingScalarFieldEnum = {
  id: 'id',
  cardHolderId: 'cardHolderId',
  reloadType: 'reloadType',
  reloadFrequency: 'reloadFrequency',
  enabled: 'enabled',
  topUpAmount: 'topUpAmount',
  belowAmount: 'belowAmount',
  creditLimitThreshold: 'creditLimitThreshold',
  lastFailedAttempt: 'lastFailedAttempt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FleetioScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  accountToken: 'accountToken',
  apiKey: 'apiKey',
  fuelType: 'fuelType',
  deleted: 'deleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FleetioFuelEntryScalarFieldEnum = {
  id: 'id',
  fleetioId: 'fleetioId',
  transactionId: 'transactionId',
  data: 'data',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MetricCaptureScalarFieldEnum = {
  id: 'id',
  date: 'date',
  name: 'name',
  value: 'value',
  unit: 'unit',
  type: 'type',
  metadata: 'metadata'
};

exports.Prisma.AdminProspectiveLeadsFileScalarFieldEnum = {
  id: 'id',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName',
  description: 'description',
  publicLink: 'publicLink',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdminProspectiveLeadsCommunicationFileScalarFieldEnum = {
  id: 'id',
  adminProspectiveLeadsFileId: 'adminProspectiveLeadsFileId',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName',
  description: 'description',
  publicLink: 'publicLink',
  actionType: 'actionType',
  executionStatus: 'executionStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalesPipeLineScalarFieldEnum = {
  id: 'id',
  email: 'email',
  vehiclesInFleet: 'vehiclesInFleet',
  monthlyFuelSpend: 'monthlyFuelSpend',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserLeadScalarFieldEnum = {
  id: 'id',
  status: 'status',
  onBoardStatus: 'onBoardStatus',
  customerType: 'customerType',
  email: 'email',
  phoneNumber: 'phoneNumber',
  firstName: 'firstName',
  lastName: 'lastName',
  title: 'title',
  ssn: 'ssn',
  ein: 'ein',
  referral: 'referral',
  customerSource: 'customerSource',
  stripeCustomerId: 'stripeCustomerId',
  businessUnderwritingProcessId: 'businessUnderwritingProcessId',
  phoneLastDateOfEdit: 'phoneLastDateOfEdit',
  emailLastDateOfEdit: 'emailLastDateOfEdit',
  isEmailVerified: 'isEmailVerified',
  isPhoneVerified: 'isPhoneVerified',
  passwordHash: 'passwordHash',
  passwordSalt: 'passwordSalt',
  passwordResetToken: 'passwordResetToken',
  passwordResetTokenCreatedAt: 'passwordResetTokenCreatedAt',
  emailVerificationHash: 'emailVerificationHash',
  emailVerificationHashCreatedAt: 'emailVerificationHashCreatedAt',
  executiveJobTitle: 'executiveJobTitle',
  dateOfBirth: 'dateOfBirth',
  submittedAt: 'submittedAt',
  statusUpdatedAt: 'statusUpdatedAt',
  message: 'message',
  salesAdminId: 'salesAdminId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ipAddress: 'ipAddress'
};

exports.Prisma.UserNotificationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  category: 'category',
  description: 'description',
  communicationMode: 'communicationMode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  additionalUserDetailId: 'additionalUserDetailId',
  otherUserDetailId: 'otherUserDetailId',
  isSmsDisabled: 'isSmsDisabled',
  isEmailDisabled: 'isEmailDisabled',
  rank: 'rank',
  optionValues: 'optionValues',
  variables: 'variables'
};

exports.Prisma.PromotionScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  promotionType: 'promotionType',
  isGlobal: 'isGlobal',
  isActive: 'isActive',
  startDate: 'startDate',
  endDate: 'endDate',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserDeviceScalarFieldEnum = {
  deviceToken: 'deviceToken',
  userProfileId: 'userProfileId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MonthlyClosingBalanceScalarFieldEnum = {
  id: 'id',
  month: 'month',
  year: 'year',
  balance: 'balance',
  businessId: 'businessId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FileChecksumScalarFieldEnum = {
  id: 'id',
  name: 'name',
  checksum: 'checksum',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EventsScalarFieldEnum = {
  id: 'id',
  eventId: 'eventId',
  eventType: 'eventType',
  step: 'step',
  processed: 'processed',
  processingError: 'processingError',
  eventData: 'eventData',
  eventSource: 'eventSource',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.HighNoteDocumentUploadScalarFieldEnum = {
  id: 'id',
  status: 'status',
  businessUnderwritingProcessId: 'businessUnderwritingProcessId',
  data: 'data',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LandingPageSubscriberListScalarFieldEnum = {
  id: 'id',
  email: 'email',
  source: 'source',
  data: 'data',
  downloadDates: 'downloadDates',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EJWardScalarFieldEnum = {
  id: 'id',
  username: 'username',
  password: 'password',
  apiKey: 'apiKey',
  token: 'token',
  apiUrl: 'apiUrl',
  tokenPersistTime: 'tokenPersistTime',
  additionalUserDetailId: 'additionalUserDetailId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ApiUsageScalarFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  feature: 'feature',
  windowStart: 'windowStart',
  requestCount: 'requestCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.RoleOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.UserProfileRoleOrderByRelevanceFieldEnum = {
  userProfileId: 'userProfileId',
  roleId: 'roleId'
};

exports.Prisma.SuperUserRoleOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.SuperUserProfileRoleOrderByRelevanceFieldEnum = {
  userProfileId: 'userProfileId',
  superUserRoleId: 'superUserRoleId'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.PermissionOrderByRelevanceFieldEnum = {
  id: 'id',
  roleId: 'roleId',
  superUserRoleId: 'superUserRoleId'
};

exports.Prisma.ResolverOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  userProfileId: 'userProfileId'
};

exports.Prisma.PermissionResolverOrderByRelevanceFieldEnum = {
  permissionId: 'permissionId',
  resolverId: 'resolverId'
};

exports.Prisma.FeatureOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  parentId: 'parentId'
};

exports.Prisma.UserProfileFeatureOrderByRelevanceFieldEnum = {
  userProfileId: 'userProfileId',
  featureId: 'featureId'
};

exports.Prisma.UserProfileResolverOrderByRelevanceFieldEnum = {
  userProfileId: 'userProfileId',
  resolverId: 'resolverId'
};

exports.Prisma.PermissionFeatureOrderByRelevanceFieldEnum = {
  permissionId: 'permissionId',
  featureId: 'featureId'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.AdditionalUserDetailOrderByRelevanceFieldEnum = {
  id: 'id',
  ssn: 'ssn',
  businessId: 'businessId',
  stripeCustomerId: 'stripeCustomerId',
  highNoteApplicationId: 'highNoteApplicationId',
  customerSupportAdminId: 'customerSupportAdminId',
  userDepositCode: 'userDepositCode',
  userProfileId: 'userProfileId',
  developerAuthorizationBearer: 'developerAuthorizationBearer'
};

exports.Prisma.UserProfileOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  otherUserDetailId: 'otherUserDetailId',
  userLeadId: 'userLeadId',
  email: 'email',
  phoneNumber: 'phoneNumber',
  firstName: 'firstName',
  lastName: 'lastName',
  passwordHash: 'passwordHash',
  passwordSalt: 'passwordSalt',
  passwordResetToken: 'passwordResetToken',
  newEmail: 'newEmail',
  emailVerificationHash: 'emailVerificationHash',
  dateOfBirth: 'dateOfBirth',
  parentId: 'parentId',
  permissionId: 'permissionId',
  accountDisplaySettingId: 'accountDisplaySettingId',
  parentCompanyUserAuthorizedProfileId: 'parentCompanyUserAuthorizedProfileId',
  highNoteApplicationId: 'highNoteApplicationId'
};

exports.Prisma.UserTransactionsFileExportTemplateOrderByRelevanceFieldEnum = {
  id: 'id',
  userProfileId: 'userProfileId',
  templateName: 'templateName',
  fields: 'fields'
};

exports.Prisma.AccountDisplaySettingOrderByRelevanceFieldEnum = {
  id: 'id',
  userProfileId: 'userProfileId'
};

exports.Prisma.AzureExternalUserInvitationOrderByRelevanceFieldEnum = {
  id: 'id',
  userProfileId: 'userProfileId',
  azureId: 'azureId'
};

exports.Prisma.AccountControlSettingsOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  preauthorizationText: 'preauthorizationText'
};

exports.Prisma.ParameterFilterOrderByRelevanceFieldEnum = {
  id: 'id',
  tag: 'tag',
  otherUserDetailId: 'otherUserDetailId'
};

exports.Prisma.OtherUserDetailOrderByRelevanceFieldEnum = {
  id: 'id',
  userProfileId: 'userProfileId'
};

exports.Prisma.ProductsOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.AlertsOrderByRelevanceFieldEnum = {
  id: 'id',
  message: 'message',
  additionalUserDetailId: 'additionalUserDetailId'
};

exports.Prisma.PreauthorizeTransactionAlertsOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  cardId: 'cardId'
};

exports.Prisma.DriverAlertsOrderByRelevanceFieldEnum = {
  id: 'id',
  message: 'message',
  fleetDriverId: 'fleetDriverId'
};

exports.Prisma.UserProductStatusOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  productId: 'productId',
  message: 'message'
};

exports.Prisma.QuickBooksDetailOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  realmId: 'realmId',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken'
};

exports.Prisma.AddressUsageOrderByRelevanceFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  streetAddress: 'streetAddress',
  streetDetails: 'streetDetails',
  state: 'state',
  city: 'city',
  zip: 'zip'
};

exports.Prisma.BusinessOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  cardName: 'cardName',
  description: 'description',
  additionalUserDetailId: 'additionalUserDetailId',
  dot: 'dot',
  ein: 'ein',
  mc: 'mc',
  collectionAdminId: 'collectionAdminId'
};

exports.Prisma.CardPaymentMethodOrderByRelevanceFieldEnum = {
  id: 'id',
  paymentMethodId: 'paymentMethodId',
  businessId: 'businessId'
};

exports.Prisma.FleetInfoOrderByRelevanceFieldEnum = {
  id: 'id',
  businessId: 'businessId'
};

exports.Prisma.AccountDocumentsOrderByRelevanceFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName'
};

exports.Prisma.StatementCustomizationSettingOrderByRelevanceFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  columns: 'columns'
};

exports.Prisma.FactorDocumentOrderByRelevanceFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  w9form: 'w9form',
  insuranceCert: 'insuranceCert',
  articlesIncorporation: 'articlesIncorporation'
};

exports.Prisma.PlaidConnectOrderByRelevanceFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  userLeadId: 'userLeadId',
  institution: 'institution',
  itemId: 'itemId',
  accessToken: 'accessToken',
  mtExternalAccountId: 'mtExternalAccountId',
  plaidError: 'plaidError',
  stripeBankAccount: 'stripeBankAccount',
  processorToken: 'processorToken'
};

exports.Prisma.PlaidConnectPendingOrderByRelevanceFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  accessToken: 'accessToken',
  institution: 'institution',
  itemId: 'itemId'
};

exports.Prisma.UserWalletOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId'
};

exports.Prisma.UserWalletItemsOrderByRelevanceFieldEnum = {
  id: 'id',
  walletId: 'walletId',
  paymentId: 'paymentId',
  billingCycleId: 'billingCycleId',
  details: 'details',
  authorizationId: 'authorizationId',
  transactionId: 'transactionId',
  oldTransactionId: 'oldTransactionId'
};

exports.Prisma.DefaultSettingOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.CardHoldersMembershipOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  cardHolderId: 'cardHolderId',
  counterPartyId: 'counterPartyId',
  allowCategories: 'allowCategories',
  restrictCategories: 'restrictCategories',
  whitelistMerchant: 'whitelistMerchant',
  blockMerchant: 'blockMerchant',
  allowMerchant: 'allowMerchant',
  blockState: 'blockState',
  currency: 'currency',
  ACHAttempt: 'ACHAttempt',
  additionalCategory: 'additionalCategory',
  highNoteFinancialAccId: 'highNoteFinancialAccId'
};

exports.Prisma.CronInfoOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.CardOrderByRelevanceFieldEnum = {
  id: 'id',
  cardHolderId: 'cardHolderId',
  additionalUserDetailId: 'additionalUserDetailId',
  type: 'type',
  currency: 'currency',
  cardId: 'cardId',
  brand: 'brand',
  lastFour: 'lastFour',
  status: 'status',
  blockState: 'blockState',
  countries: 'countries',
  flaggedMerchantCategories: 'flaggedMerchantCategories'
};

exports.Prisma.CardMerchantsOrderByRelevanceFieldEnum = {
  id: 'id',
  cardId: 'cardId',
  cardRuleId: 'cardRuleId',
  name: 'name',
  numberOfPurchaseFrequency: 'numberOfPurchaseFrequency',
  totalSpendFrequency: 'totalSpendFrequency'
};

exports.Prisma.OperationalHoursOrderByRelevanceFieldEnum = {
  id: 'id',
  startTime: 'startTime',
  endTime: 'endTime',
  cardId: 'cardId',
  cardRuleId: 'cardRuleId'
};

exports.Prisma.CardRuleOrderByRelevanceFieldEnum = {
  id: 'id',
  cardHolderId: 'cardHolderId',
  name: 'name',
  description: 'description',
  blockState: 'blockState',
  countries: 'countries',
  flaggedMerchantCategories: 'flaggedMerchantCategories'
};

exports.Prisma.FleetDriverOrderByRelevanceFieldEnum = {
  id: 'id',
  promptCode: 'promptCode',
  additionalUserDetailId: 'additionalUserDetailId',
  businessId: 'businessId',
  cardId: 'cardId',
  vehicleSharingcardId: 'vehicleSharingcardId',
  name: 'name',
  email: 'email',
  phoneNumber: 'phoneNumber',
  passwordHash: 'passwordHash',
  passwordSalt: 'passwordSalt',
  passwordResetToken: 'passwordResetToken',
  notes: 'notes',
  deviceTokens: 'deviceTokens'
};

exports.Prisma.FleetOrderByRelevanceFieldEnum = {
  id: 'id',
  promptCode: 'promptCode',
  additionalUserDetailId: 'additionalUserDetailId',
  businessId: 'businessId',
  cardId: 'cardId',
  driverSharingCardId: 'driverSharingCardId',
  fleetName: 'fleetName',
  vin: 'vin',
  fleetLicensePlate: 'fleetLicensePlate',
  make: 'make',
  model: 'model',
  year: 'year',
  provisionState: 'provisionState'
};

exports.Prisma.FleetOdometerReadingOrderByRelevanceFieldEnum = {
  id: 'id',
  fleetId: 'fleetId',
  eldOdometerReadingTime: 'eldOdometerReadingTime'
};

exports.Prisma.CardHolderSpendingOrderByRelevanceFieldEnum = {
  id: 'id',
  cardHolderId: 'cardHolderId',
  interval: 'interval',
  category: 'category'
};

exports.Prisma.CardReplacementOrderByRelevanceFieldEnum = {
  id: 'id',
  cardId: 'cardId',
  replacement_for: 'replacement_for',
  replacement_reason: 'replacement_reason'
};

exports.Prisma.CardSpendingOrderByRelevanceFieldEnum = {
  id: 'id',
  cardId: 'cardId',
  cardRuleId: 'cardRuleId',
  interval: 'interval',
  category: 'category',
  highNoteSpendRuleId: 'highNoteSpendRuleId',
  highNoteVelocityRuleId: 'highNoteVelocityRuleId'
};

exports.Prisma.CardShippingOrderByRelevanceFieldEnum = {
  id: 'id',
  cardId: 'cardId',
  cardGroupOrderId: 'cardGroupOrderId',
  deliveryName: 'deliveryName',
  deliveryService: 'deliveryService',
  deliveryPartner: 'deliveryPartner',
  trackingNumber: 'trackingNumber',
  trackingUrl: 'trackingUrl'
};

exports.Prisma.CardOrderOrderByRelevanceFieldEnum = {
  id: 'id',
  cardProfileId: 'cardProfileId',
  deliveryType: 'deliveryType',
  notes: 'notes',
  streetAddress: 'streetAddress',
  streetDetails: 'streetDetails',
  state: 'state',
  city: 'city',
  zip: 'zip',
  cardHolderId: 'cardHolderId'
};

exports.Prisma.TransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  highnoteTransactionId: 'highnoteTransactionId',
  merchantName: 'merchantName',
  driverName: 'driverName',
  merchantState: 'merchantState',
  merchantPostCd: 'merchantPostCd',
  merchantCountry: 'merchantCountry',
  cardId: 'cardId',
  cardHolderId: 'cardHolderId',
  driverId: 'driverId',
  vehicleName: 'vehicleName',
  vehicleVIN: 'vehicleVIN',
  authorizationId: 'authorizationId',
  memo: 'memo',
  fleetId: 'fleetId',
  cardRuleId: 'cardRuleId'
};

exports.Prisma.AccountTagOrderByRelevanceFieldEnum = {
  id: 'id',
  promptCode: 'promptCode',
  additionalUserDetailId: 'additionalUserDetailId',
  parentId: 'parentId',
  tagId: 'tagId',
  title: 'title',
  description: 'description'
};

exports.Prisma.CardAccountTagOrderByRelevanceFieldEnum = {
  id: 'id',
  cardId: 'cardId',
  accountTagId: 'accountTagId'
};

exports.Prisma.FleetAccountTagOrderByRelevanceFieldEnum = {
  id: 'id',
  fleetId: 'fleetId',
  accountTagId: 'accountTagId'
};

exports.Prisma.FleetDriverAccountTagOrderByRelevanceFieldEnum = {
  id: 'id',
  fleetDriverId: 'fleetDriverId',
  accountTagId: 'accountTagId'
};

exports.Prisma.TransactionAccountTagOrderByRelevanceFieldEnum = {
  id: 'id',
  transactionId: 'transactionId',
  accountTagId: 'accountTagId'
};

exports.Prisma.OldTransactionAccountTagOrderByRelevanceFieldEnum = {
  id: 'id',
  oldTransactionId: 'oldTransactionId',
  accountTagId: 'accountTagId'
};

exports.Prisma.AuthorizationAccountTagOrderByRelevanceFieldEnum = {
  id: 'id',
  authorizationId: 'authorizationId',
  accountTagId: 'accountTagId'
};

exports.Prisma.OldTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  highnoteTransactionId: 'highnoteTransactionId',
  merchantName: 'merchantName',
  driverName: 'driverName',
  merchantState: 'merchantState',
  merchantPostCd: 'merchantPostCd',
  merchantCountry: 'merchantCountry',
  cardId: 'cardId',
  cardHolderId: 'cardHolderId',
  driverId: 'driverId',
  vehicleName: 'vehicleName',
  vehicleVIN: 'vehicleVIN',
  authorizationId: 'authorizationId',
  memo: 'memo',
  fleetId: 'fleetId',
  userWalletItemsId: 'userWalletItemsId',
  cardRuleId: 'cardRuleId'
};

exports.Prisma.ImportedTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  merchantName: 'merchantName',
  driverName: 'driverName',
  merchantState: 'merchantState',
  merchantPostCd: 'merchantPostCd',
  cardHolderId: 'cardHolderId',
  vehicleName: 'vehicleName',
  vehicleVIN: 'vehicleVIN',
  memo: 'memo'
};

exports.Prisma.TransactionReceiptOrderByRelevanceFieldEnum = {
  id: 'id',
  txnId: 'txnId',
  authzId: 'authzId',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName'
};

exports.Prisma.OldTransactionReceiptOrderByRelevanceFieldEnum = {
  id: 'id',
  txnId: 'txnId',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName'
};

exports.Prisma.AuthorizationOrderByRelevanceFieldEnum = {
  id: 'id',
  highnoteTransactionId: 'highnoteTransactionId',
  merchantName: 'merchantName',
  merchantState: 'merchantState',
  merchantPostCd: 'merchantPostCd',
  merchantCountry: 'merchantCountry',
  merchantCategory: 'merchantCategory',
  cardId: 'cardId',
  cardHolderId: 'cardHolderId',
  driverName: 'driverName',
  driverId: 'driverId',
  vehicleName: 'vehicleName',
  vehicleId: 'vehicleId',
  vehicleVIN: 'vehicleVIN',
  memo: 'memo',
  cardRuleId: 'cardRuleId'
};

exports.Prisma.BillingCycleOrderByRelevanceFieldEnum = {
  id: 'id',
  cardHolderId: 'cardHolderId',
  invoiceId: 'invoiceId',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName'
};

exports.Prisma.BillingCycleItemsOrderByRelevanceFieldEnum = {
  id: 'id',
  itemName: 'itemName',
  billingCycleId: 'billingCycleId'
};

exports.Prisma.PaymentHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  payId: 'payId',
  accountId: 'accountId',
  cardHolderId: 'cardHolderId',
  repaymentId: 'repaymentId',
  billingCycleId: 'billingCycleId',
  modernTreasuryStatus: 'modernTreasuryStatus'
};

exports.Prisma.ManualPaymentHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  payIntentId: 'payIntentId',
  chargeId: 'chargeId',
  cardHolderId: 'cardHolderId'
};

exports.Prisma.RefundPaymentsOrderByRelevanceFieldEnum = {
  id: 'id',
  refundId: 'refundId',
  chargeId: 'chargeId',
  paymentId: 'paymentId',
  manualPaymentHistoryId: 'manualPaymentHistoryId',
  cardHolderId: 'cardHolderId'
};

exports.Prisma.DisputePaymentsOrderByRelevanceFieldEnum = {
  id: 'id',
  disputeId: 'disputeId',
  chargeId: 'chargeId',
  cardHolderId: 'cardHolderId',
  paymentId: 'paymentId',
  manualPaymentHistoryId: 'manualPaymentHistoryId',
  reason: 'reason'
};

exports.Prisma.UserSignUpBonusOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId'
};

exports.Prisma.UserLendFlowDataOrderByRelevanceFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  applicationId: 'applicationId',
  ekata: 'ekata',
  experianUccs: 'experianUccs',
  experianBankruptcies: 'experianBankruptcies',
  experianJudgments: 'experianJudgments',
  experianLiens: 'experianLiens',
  experianIntelliscore: 'experianIntelliscore',
  experianFsr: 'experianFsr',
  dnbFiL4: 'dnbFiL4',
  middesk: 'middesk',
  ocrolusCfa: 'ocrolusCfa'
};

exports.Prisma.UnderwritingDataOrderByRelevanceFieldEnum = {
  id: 'id',
  userLendFlowId: 'userLendFlowId',
  applicationId: 'applicationId',
  registrationStatus: 'registrationStatus'
};

exports.Prisma.AdminUnderwritingSettingOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.AdminOrderByRelevanceFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  identifier: 'identifier',
  email: 'email',
  passwordHash: 'passwordHash',
  passwordSalt: 'passwordSalt'
};

exports.Prisma.AdminRoleOrderByRelevanceFieldEnum = {
  adminId: 'adminId',
  adminRoleMasterId: 'adminRoleMasterId'
};

exports.Prisma.AdminRoleMasterOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.AdminPermissionOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.AdminPermissionRoleMasterOrderByRelevanceFieldEnum = {
  adminRoleMasterId: 'adminRoleMasterId',
  adminPermissionId: 'adminPermissionId'
};

exports.Prisma.SessionOrderByRelevanceFieldEnum = {
  id: 'id',
  adminId: 'adminId'
};

exports.Prisma.AdminFuelDiscountOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.AdminSignUpBonusOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.AdminReferralBonusOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.ReferralOrderByRelevanceFieldEnum = {
  id: 'id',
  referredBy: 'referredBy',
  referred: 'referred',
  additionalUserDetailId: 'additionalUserDetailId'
};

exports.Prisma.ReferralCodeOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId'
};

exports.Prisma.ReferralCreditOrderByRelevanceFieldEnum = {
  id: 'id',
  referredById: 'referredById',
  referralCode: 'referralCode',
  additionalUserDetailId: 'additionalUserDetailId'
};

exports.Prisma.AffiliateReferralOrderByRelevanceFieldEnum = {
  id: 'id',
  affiliateCode: 'affiliateCode',
  email: 'email',
  referred: 'referred'
};

exports.Prisma.AdminEmailOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  password: 'password'
};

exports.Prisma.EmailTemplatesOrderByRelevanceFieldEnum = {
  id: 'id',
  templateName: 'templateName',
  emailId: 'emailId'
};

exports.Prisma.SendGridTemplatesOrderByRelevanceFieldEnum = {
  id: 'id',
  templateId: 'templateId',
  variableNames: 'variableNames'
};

exports.Prisma.SmsTemplatesOrderByRelevanceFieldEnum = {
  id: 'id',
  message: 'message'
};

exports.Prisma.MailTypeOrderByRelevanceFieldEnum = {
  id: 'id',
  templateName: 'templateName'
};

exports.Prisma.AdminCollectionsWorkflowSettingsOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.AdminBlogsOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  blogUrlId: 'blogUrlId',
  summary: 'summary',
  blog: 'blog'
};

exports.Prisma.AdminBlogImagesOrderByRelevanceFieldEnum = {
  id: 'id',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName',
  adminBlogId: 'adminBlogId'
};

exports.Prisma.AdminInTheNewsOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  summary: 'summary',
  newsLink: 'newsLink',
  content: 'content'
};

exports.Prisma.AdminCardSettingOrderByRelevanceFieldEnum = {
  id: 'id',
  categories: 'categories',
  oldCategories: 'oldCategories',
  restrictedMerchants: 'restrictedMerchants'
};

exports.Prisma.AdminApprovalSettingOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId'
};

exports.Prisma.ApproveAutoUnderwritingSettingOrderByRelevanceFieldEnum = {
  id: 'id',
  isLicenseVerified: 'isLicenseVerified',
  isBusinessNameVerified: 'isBusinessNameVerified',
  isPeopleVerified: 'isPeopleVerified',
  isOfficeAddressVerified: 'isOfficeAddressVerified',
  sosActivationStatus: 'sosActivationStatus',
  sosDomesticActivationStatus: 'sosDomesticActivationStatus',
  isTinMatch: 'isTinMatch',
  registrationStatus: 'registrationStatus',
  isPhoneRisk: 'isPhoneRisk'
};

exports.Prisma.RejectUnderwritingSettingOrderByRelevanceFieldEnum = {
  id: 'id',
  isTinMatch: 'isTinMatch'
};

exports.Prisma.AdminCommentsOrderByRelevanceFieldEnum = {
  id: 'id',
  adminId: 'adminId',
  adminFname: 'adminFname',
  adminLname: 'adminLname',
  comments: 'comments',
  additionalUserDetailId: 'additionalUserDetailId',
  userLeadId: 'userLeadId'
};

exports.Prisma.AdminActivityLogOrderByRelevanceFieldEnum = {
  id: 'id',
  adminId: 'adminId',
  userLeadId: 'userLeadId',
  userProfileId: 'userProfileId',
  activity: 'activity'
};

exports.Prisma.UserActivityLogOrderByRelevanceFieldEnum = {
  id: 'id',
  userProfileId: 'userProfileId',
  activity: 'activity'
};

exports.Prisma.LendflowProductSchemaOrderByRelevanceFieldEnum = {
  id: 'id',
  product: 'product',
  verificationObjects: 'verificationObjects'
};

exports.Prisma.EldDeviceInfoOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId'
};

exports.Prisma.EldDeviceDetailsOrderByRelevanceFieldEnum = {
  id: 'id',
  deviceId: 'deviceId',
  fleetId: 'fleetId',
  eldDeviceInfoId: 'eldDeviceInfoId'
};

exports.Prisma.EldDeviceMappingHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  deviceId: 'deviceId',
  fleetId: 'fleetId',
  additionalUserDetailId: 'additionalUserDetailId'
};

exports.Prisma.EmailWorkflowOrderByRelevanceFieldEnum = {
  id: 'id',
  emailId: 'emailId',
  emailTemplate: 'emailTemplate',
  emailTemplateSubject: 'emailTemplateSubject',
  smsTemplate: 'smsTemplate'
};

exports.Prisma.BusinessUnderwritingProcessOrderByRelevanceFieldEnum = {
  id: 'id',
  businessId: 'businessId',
  userLeadId: 'userLeadId',
  message: 'message'
};

exports.Prisma.BusinessUnderwritingDataOrderByRelevanceFieldEnum = {
  id: 'id',
  businessUnderwritingProcessId: 'businessUnderwritingProcessId',
  externalId: 'externalId',
  message: 'message'
};

exports.Prisma.UnderwritingDataResultOrderByRelevanceFieldEnum = {
  id: 'id',
  businessUnderwritingProcessId: 'businessUnderwritingProcessId'
};

exports.Prisma.LedgerOrderByRelevanceFieldEnum = {
  id: 'id',
  normalBalance: 'normalBalance'
};

exports.Prisma.LedgerTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  transactionType: 'transactionType',
  transactionDetail: 'transactionDetail'
};

exports.Prisma.LedgerEntriesOrderByRelevanceFieldEnum = {
  id: 'id',
  direction: 'direction',
  ledgerTransactionId: 'ledgerTransactionId'
};

exports.Prisma.AdminSystemHealthOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description'
};

exports.Prisma.UserFunctionalityTrackerByAdminOrderByRelevanceFieldEnum = {
  id: 'id',
  type: 'type',
  identifier: 'identifier',
  details: 'details'
};

exports.Prisma.RepaymentOrderByRelevanceFieldEnum = {
  id: 'id',
  cardHolderId: 'cardHolderId'
};

exports.Prisma.EmailHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  messageId: 'messageId',
  status: 'status'
};

exports.Prisma.LogFilesOrderByRelevanceFieldEnum = {
  id: 'id',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName'
};

exports.Prisma.LateFeesTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  billingCycleId: 'billingCycleId',
  cardHolderId: 'cardHolderId'
};

exports.Prisma.MonthlyCardFeeOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.StripeDetailsOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  userLeadId: 'userLeadId',
  stripeAccountId: 'stripeAccountId',
  stripePersonId: 'stripePersonId'
};

exports.Prisma.AutoReloadSettingOrderByRelevanceFieldEnum = {
  id: 'id',
  cardHolderId: 'cardHolderId'
};

exports.Prisma.FleetioOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  accountToken: 'accountToken',
  apiKey: 'apiKey'
};

exports.Prisma.FleetioFuelEntryOrderByRelevanceFieldEnum = {
  id: 'id',
  fleetioId: 'fleetioId',
  transactionId: 'transactionId'
};

exports.Prisma.MetricCaptureOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.AdminProspectiveLeadsFileOrderByRelevanceFieldEnum = {
  id: 'id',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName',
  description: 'description',
  publicLink: 'publicLink'
};

exports.Prisma.AdminProspectiveLeadsCommunicationFileOrderByRelevanceFieldEnum = {
  id: 'id',
  adminProspectiveLeadsFileId: 'adminProspectiveLeadsFileId',
  fileName: 'fileName',
  fileExtension: 'fileExtension',
  folderName: 'folderName',
  description: 'description',
  publicLink: 'publicLink'
};

exports.Prisma.SalesPipeLineOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  vehiclesInFleet: 'vehiclesInFleet',
  monthlyFuelSpend: 'monthlyFuelSpend'
};

exports.Prisma.UserLeadOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  phoneNumber: 'phoneNumber',
  firstName: 'firstName',
  lastName: 'lastName',
  title: 'title',
  ssn: 'ssn',
  ein: 'ein',
  referral: 'referral',
  stripeCustomerId: 'stripeCustomerId',
  businessUnderwritingProcessId: 'businessUnderwritingProcessId',
  passwordHash: 'passwordHash',
  passwordSalt: 'passwordSalt',
  passwordResetToken: 'passwordResetToken',
  emailVerificationHash: 'emailVerificationHash',
  dateOfBirth: 'dateOfBirth',
  message: 'message',
  salesAdminId: 'salesAdminId',
  ipAddress: 'ipAddress'
};

exports.Prisma.UserNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  description: 'description',
  additionalUserDetailId: 'additionalUserDetailId',
  otherUserDetailId: 'otherUserDetailId',
  optionValues: 'optionValues',
  variables: 'variables'
};

exports.Prisma.PromotionOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId',
  description: 'description'
};

exports.Prisma.UserDeviceOrderByRelevanceFieldEnum = {
  deviceToken: 'deviceToken',
  userProfileId: 'userProfileId'
};

exports.Prisma.MonthlyClosingBalanceOrderByRelevanceFieldEnum = {
  id: 'id',
  businessId: 'businessId'
};

exports.Prisma.FileChecksumOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  checksum: 'checksum'
};

exports.Prisma.EventsOrderByRelevanceFieldEnum = {
  id: 'id',
  eventId: 'eventId',
  eventType: 'eventType'
};

exports.Prisma.HighNoteDocumentUploadOrderByRelevanceFieldEnum = {
  id: 'id',
  status: 'status',
  businessUnderwritingProcessId: 'businessUnderwritingProcessId'
};

exports.Prisma.LandingPageSubscriberListOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email'
};

exports.Prisma.EJWardOrderByRelevanceFieldEnum = {
  id: 'id',
  username: 'username',
  password: 'password',
  apiKey: 'apiKey',
  token: 'token',
  apiUrl: 'apiUrl',
  additionalUserDetailId: 'additionalUserDetailId'
};

exports.Prisma.ApiUsageOrderByRelevanceFieldEnum = {
  id: 'id',
  additionalUserDetailId: 'additionalUserDetailId'
};
exports.ENUM_CHILD_USER_TYPE = {
  OWNER: 'OWNER',
  ACCOUNT_MANAGER: 'ACCOUNT_MANAGER',
  CARD_ADMIN: 'CARD_ADMIN',
  CARD_MANAGER: 'CARD_MANAGER',
  BOOKKEEPER: 'BOOKKEEPER'
};

exports.ENUM_SUPER_USER_USER_TYPE = {
  SUPER_USER: 'SUPER_USER',
  CONTRIBUTOR: 'CONTRIBUTOR'
};

exports.ENUM_CUSTOMER_TYPE = {
  NOT_SET: 'NOT_SET',
  CREDIT: 'CREDIT',
  CREDIT_PLUS: 'CREDIT_PLUS',
  CREDIT_ENTERPRISE: 'CREDIT_ENTERPRISE',
  PREPAID: 'PREPAID',
  PREPAID_PLUS: 'PREPAID_PLUS',
  PREPAID_ENTERPRISE: 'PREPAID_ENTERPRISE',
  LARGE_FLEETS: 'LARGE_FLEETS'
};

exports.ENUM_PAYMENT_SOURCE = {
  STRIPE: 'STRIPE',
  HIGHNOTE: 'HIGHNOTE'
};

exports.ENUM_CUSTOMER_TIER = {
  TIER_1: 'TIER_1',
  TIER_2: 'TIER_2',
  TIER_3: 'TIER_3',
  TIER_4: 'TIER_4',
  TIER_5: 'TIER_5',
  NONE: 'NONE'
};

exports.ENUM_JOB_TITLE = {
  OWNER: 'OWNER',
  CEO: 'CEO',
  PRESIDENT: 'PRESIDENT',
  PARTNER: 'PARTNER',
  EXECUTIVE: 'EXECUTIVE',
  MANAGER: 'MANAGER'
};

exports.ENUM_TRANSACTION_FILE_EXPORT_TYPE = {
  PENDING_TRANSACTION_CSV_DOWNLOAD: 'PENDING_TRANSACTION_CSV_DOWNLOAD',
  SETTLED_TRANSACTION_CSV_DOWNLOAD: 'SETTLED_TRANSACTION_CSV_DOWNLOAD',
  PDF_STATEMENT_DOWNLOAD: 'PDF_STATEMENT_DOWNLOAD'
};

exports.ENUM_TIME_ZONE = {
  USER: 'USER',
  UTC: 'UTC',
  CT: 'CT',
  PST: 'PST',
  EST: 'EST'
};

exports.ENUM_COLOR_SCHEME = {
  DEFAULT: 'DEFAULT',
  COOL_AND_FRESH: 'COOL_AND_FRESH',
  NATURAL_AND_EARTHY: 'NATURAL_AND_EARTHY',
  FUTURISTIC: 'FUTURISTIC'
};

exports.AZURE_INVITATION_STATUS = {
  NOT_INVITED: 'NOT_INVITED',
  INVITATION_SENT: 'INVITATION_SENT',
  ACCEPTED: 'ACCEPTED'
};

exports.ENUM_DYNAMIC_PURCHASE_CONTROL_SETTING = {
  CARD: 'CARD',
  DRIVER: 'DRIVER',
  VEHICLE: 'VEHICLE'
};

exports.ENUM_USERS_READ_WRITE_PERMISSION = {
  READ: 'READ',
  READ_AND_WRITE: 'READ_AND_WRITE'
};

exports.ENUM_CHILD_USER_STATUS = {
  INVITATION_SENT: 'INVITATION_SENT',
  ACCOUNT_ACTIVE: 'ACCOUNT_ACTIVE',
  ACCOUNT_INACTIVE: 'ACCOUNT_INACTIVE'
};

exports.ENUM_PRODUCT_NAMES = {
  FUELCARD: 'FUELCARD',
  FACTOR: 'FACTOR'
};

exports.ENUM_ALERT_TYPE = {
  INVOICE_CREATION: 'INVOICE_CREATION',
  TRANSACTION_DECLINE: 'TRANSACTION_DECLINE',
  PAYMENT_FAILURE: 'PAYMENT_FAILURE',
  TRANSACTION_CONTROL_DISTANCE: 'TRANSACTION_CONTROL_DISTANCE',
  AUTO_RELOAD_SUCCESS: 'AUTO_RELOAD_SUCCESS',
  AUTO_RELOAD_FAILED: 'AUTO_RELOAD_FAILED',
  SCHEDULE_PAYMENTS_SUCCESS: 'SCHEDULE_PAYMENTS_SUCCESS',
  SCHEDULE_PAYMENTS_FAILED: 'SCHEDULE_PAYMENTS_FAILED',
  TEMPERORY_CREDIT_LIMIT_INCREASE_SUCCESS: 'TEMPERORY_CREDIT_LIMIT_INCREASE_SUCCESS',
  TEMPERORY_CREDIT_LIMIT_INCREASE_FAILED: 'TEMPERORY_CREDIT_LIMIT_INCREASE_FAILED',
  REPAYMENT_SUCCESS: 'REPAYMENT_SUCCESS',
  REPAYMENT_FAILED: 'REPAYMENT_FAILED',
  CARD_DELIVERY_STATUS_UPDATED: 'CARD_DELIVERY_STATUS_UPDATED',
  CARD_POLICY_UPDATED: 'CARD_POLICY_UPDATED'
};

exports.ENUM_PREAUTHORIZED_STATUS = {
  AUTHORIZED: 'AUTHORIZED',
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  SUCCESSFUL: 'SUCCESSFUL'
};

exports.ENUM_DRIVER_ALERT_TYPE = {
  MEMO_PROMPT: 'MEMO_PROMPT',
  REQUIRE_RECEIPT: 'REQUIRE_RECEIPT'
};

exports.ENUM_USER_ACCOUNT_STATUS = {
  ONBOARD: 'ONBOARD',
  IN_VERIFICATION: 'IN_VERIFICATION',
  ON_HOLD: 'ON_HOLD',
  VERIFIED_WITHOUT_DEPOSIT: 'VERIFIED_WITHOUT_DEPOSIT',
  VERIFIED: 'VERIFIED',
  REJECTED: 'REJECTED',
  CLOSED: 'CLOSED',
  DELETED: 'DELETED',
  COMPLETED: 'COMPLETED',
  HIGH_NOTE_PENDING_APPROVAL: 'HIGH_NOTE_PENDING_APPROVAL',
  PENDING_APPROVAL: 'PENDING_APPROVAL'
};

exports.ENUM_ADDRESS_TYPE = {
  PERMANENT: 'PERMANENT',
  DELIVERY: 'DELIVERY',
  HOME: 'HOME'
};

exports.ENUM_BUSINESS_TYPE = {
  LLC: 'LLC',
  C_CORP: 'C_CORP',
  S_CORP: 'S_CORP',
  NON_PROFIT_ORGANIZATION: 'NON_PROFIT_ORGANIZATION',
  SOLE_PROPRIETORSHIP: 'SOLE_PROPRIETORSHIP',
  LLP: 'LLP',
  OTHER: 'OTHER'
};

exports.ENUM_COMPANY_TYPE = {
  REALESTATE: 'REALESTATE',
  RETAIL: 'RETAIL',
  CONSULTING: 'CONSULTING',
  INTERNET: 'INTERNET',
  TRANSPORTATION: 'TRANSPORTATION',
  TRUCKING: 'TRUCKING',
  CONSTRUCTION: 'CONSTRUCTION',
  OTHER: 'OTHER'
};

exports.ENUM_DELIVERY_TYPE = {
  DAYS_2: 'DAYS_2',
  DAYS_5_7: 'DAYS_5_7'
};

exports.ENUM_PAYMENT_METHOD_TYPE = {
  ACH: 'ACH',
  CARD: 'CARD',
  NOT_SET: 'NOT_SET'
};

exports.ENUM_LENDFLOW_APPLICATION_STATUS = {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  PENDING: 'PENDING'
};

exports.ENUM_FLEET_TYPE = {
  HEAVY: 'HEAVY',
  MIXED: 'MIXED',
  LIGHT: 'LIGHT'
};

exports.ENUM_ACCOUNT_FILE_TYPE = {
  COMPANY_INCORPORATION: 'COMPANY_INCORPORATION',
  STATEMENT_1: 'STATEMENT_1',
  STATEMENT_2: 'STATEMENT_2',
  STATEMENT_3: 'STATEMENT_3',
  DRIVER_LICENCE_FRONT: 'DRIVER_LICENCE_FRONT',
  DRIVER_LICENCE_BACK: 'DRIVER_LICENCE_BACK',
  INVOICE: 'INVOICE',
  LEGAL: 'LEGAL',
  CUSTOMER_SUPPORT: 'CUSTOMER_SUPPORT',
  HELP_GUIDE: 'HELP_GUIDE',
  OTHERS: 'OTHERS'
};

exports.ENUM_STATEMENT_CUSTOMIZATION_CATEGORIZATION = {
  CARD: 'CARD',
  DRIVER: 'DRIVER',
  VEHICLE: 'VEHICLE',
  TRANSACTION_TAG: 'TRANSACTION_TAG',
  CARD_TAG: 'CARD_TAG',
  DRIVER_TAG: 'DRIVER_TAG',
  VEHICLE_TAG: 'VEHICLE_TAG'
};

exports.ENUM_PLAID_BANK_ACCOUNT_TYPE = {
  CHECKING: 'CHECKING',
  SAVINGS: 'SAVINGS'
};

exports.ENUM_WALLET_TYPE = {
  REFFERRALBONUS: 'REFFERRALBONUS',
  SIGNONBONUS: 'SIGNONBONUS',
  CASH: 'CASH',
  ADMINCASH: 'ADMINCASH',
  REFUND: 'REFUND'
};

exports.ENUM_WALLET_ITEMS_TYPE = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT'
};

exports.ENUM_WALLET_ACTIVITY_TYPE = {
  MONTHLY_CARD_FEE: 'MONTHLY_CARD_FEE',
  TRANSACTION: 'TRANSACTION',
  PAYMENTS: 'PAYMENTS',
  PREMIUM_CARD_ORDER: 'PREMIUM_CARD_ORDER',
  REFUND: 'REFUND',
  DISPUTE: 'DISPUTE',
  ADMIN_RECHARGE: 'ADMIN_RECHARGE',
  PAYMENT_REFUND: 'PAYMENT_REFUND',
  ADMIN_RECHARGE_REVERSAL: 'ADMIN_RECHARGE_REVERSAL'
};

exports.ENUM_CREDIT_CYCLE_TYPE = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY'
};

exports.ENUM_CARDHOLDER_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  BLOCKED: 'BLOCKED'
};

exports.ENUM_CARD_HOLDER_TYPE = {
  INDIVIDUAL: 'INDIVIDUAL',
  COMPANY: 'COMPANY'
};

exports.ENUM_CRON_NAMES = {
  EXPORT_USER_DATA: 'EXPORT_USER_DATA',
  MANUAL_CREATE_ACH: 'MANUAL_CREATE_ACH',
  MANUAL_SEND_TO_LENDFLOW: 'MANUAL_SEND_TO_LENDFLOW'
};

exports.ENUM_CARD_TYPE = {
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL'
};

exports.ENUM_TELEMATICS_SECURITY = {
  OFF: 'OFF',
  MONITOR: 'MONITOR',
  BLOCK: 'BLOCK',
  BLOCK_BROAD_LOCATION: 'BLOCK_BROAD_LOCATION'
};

exports.ENUM_CARD_UNLOCK_STEP = {
  UNINITIATED: 'UNINITIATED',
  CARD_DETAILS_PROVIDED: 'CARD_DETAILS_PROVIDED',
  LICENSE_PLATE_PROVIDED: 'LICENSE_PLATE_PROVIDED',
  ODOMETER_READING_PROVIDED: 'ODOMETER_READING_PROVIDED'
};

exports.ENUM_GENERIC_ID_PROMPT_MODE = {
  NONE: 'NONE',
  VERIFY: 'VERIFY',
  VERIFY_AND_ASSIGN: 'VERIFY_AND_ASSIGN'
};

exports.ENUM_GENERIC_ID_PROMPT_ENTITY_TYPE = {
  DRIVER: 'DRIVER',
  VEHICLE: 'VEHICLE',
  DRIVER_TAG: 'DRIVER_TAG',
  VEHICLE_TAG: 'VEHICLE_TAG',
  CARD_TAG: 'CARD_TAG'
};

exports.ENUM_PLATFORM_TYPE = {
  STRIPE: 'STRIPE',
  HIGHNOTE: 'HIGHNOTE'
};

exports.ENUM_CARD_SHARING = {
  DRIVER_SHARING: 'DRIVER_SHARING',
  VEHICLE_SHARING: 'VEHICLE_SHARING',
  NONE: 'NONE'
};

exports.ENUM_STRIPE_CARD_PROGRAM_TYPE = {
  DEFAULT: 'DEFAULT',
  FUEL_AND_MAINTENANCE_NO_PROMPT: 'FUEL_AND_MAINTENANCE_NO_PROMPT',
  NO_RESTRICTIONS_ODOMETER_VEHICLE_ID_PROMPT: 'NO_RESTRICTIONS_ODOMETER_VEHICLE_ID_PROMPT',
  NO_RESTRICTIONS_GENERIC_ID_ODOMETER_PROMPT: 'NO_RESTRICTIONS_GENERIC_ID_ODOMETER_PROMPT',
  NO_RESTRICTIONS_GENERIC_ID_PROMPT: 'NO_RESTRICTIONS_GENERIC_ID_PROMPT'
};

exports.ENUM_AUTHORIZATION_METHOD = {
  ONLINE: 'ONLINE',
  SWIPE: 'SWIPE',
  CHIP: 'CHIP',
  CONTACTLESS: 'CONTACTLESS',
  KEYED_IN: 'KEYED_IN'
};

exports.ENUM_DYNAMIC_PURCHASE_CONTROL_ALLOWED_FUEL_CATEGORIES = {
  ALL_CATEGORIES: 'ALL_CATEGORIES',
  AVIATION_FUEL: 'AVIATION_FUEL',
  DISPENSED_DIESEL: 'DISPENSED_DIESEL',
  DISPENSED_ELECTRIC: 'DISPENSED_ELECTRIC',
  DISPENSED_GASOLINE: 'DISPENSED_GASOLINE',
  DISPENSED_KEROSENE: 'DISPENSED_KEROSENE',
  DISPENSED_NATURAL_GAS: 'DISPENSED_NATURAL_GAS',
  DISPENSED_OFF_ROAD_FUEL: 'DISPENSED_OFF_ROAD_FUEL',
  MARINE_FUEL: 'MARINE_FUEL',
  PACKAGED_FUEL: 'PACKAGED_FUEL'
};

exports.ENUM_DYNAMIC_PURCHASE_CONTROL_ALLOWED_NON_FUEL_CATEGORIES = {
  ALCOHOL: 'ALCOHOL',
  ALL_CATEGORIES: 'ALL_CATEGORIES',
  AVIATION_PRODUCTS_AND_SERVICES: 'AVIATION_PRODUCTS_AND_SERVICES',
  FOOD: 'FOOD',
  HEALTH_AND_BEAUTY_CARE: 'HEALTH_AND_BEAUTY_CARE',
  MARINE_PRODUCTS_AND_SERVICES: 'MARINE_PRODUCTS_AND_SERVICES',
  MERCHANDISE: 'MERCHANDISE',
  MONEY_ORDER: 'MONEY_ORDER',
  PREPAID_AND_BILL_PAY: 'PREPAID_AND_BILL_PAY',
  PUBLICATIONS: 'PUBLICATIONS',
  STORE_SERVICE: 'STORE_SERVICE',
  TOBACCO: 'TOBACCO',
  VEHICLE_PRODUCTS_AND_SERVICES: 'VEHICLE_PRODUCTS_AND_SERVICES'
};

exports.ENUM_CLASSIFICATION = {
  FUEL: 'FUEL',
  VEHICLE: 'VEHICLE',
  BUSINESS: 'BUSINESS',
  OTHER: 'OTHER'
};

exports.ENUM_DAY_OF_WEEK = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY'
};

exports.ENUM_FLEET_DRIVER_STATUS = {
  INVITATION_SENT: 'INVITATION_SENT',
  ACCOUNT_CREATED: 'ACCOUNT_CREATED',
  NOT_INVITED: 'NOT_INVITED',
  DELETED: 'DELETED'
};

exports.ENUM_FUEL_TYPE = {
  DIESEL: 'DIESEL',
  UNLEADED_PLUS: 'UNLEADED_PLUS',
  UNLEADED_REGULAR: 'UNLEADED_REGULAR',
  UNLEADED_SUPER: 'UNLEADED_SUPER',
  OTHER: 'OTHER'
};

exports.ENUM_FLEET_STATUS = {
  DELETED: 'DELETED',
  ACTIVE: 'ACTIVE'
};

exports.ENUM_ODOMETER = {
  KMS: 'KMS',
  MILES: 'MILES',
  HOUR: 'HOUR'
};

exports.ENUM_CARDSHIPPING_TYPE = {
  BULK: 'BULK',
  INDIVIDUAL: 'INDIVIDUAL'
};

exports.ENUM_DELIVERY_STATUS = {
  PENDING: 'PENDING',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED',
  RETURNED: 'RETURNED',
  FAILURE: 'FAILURE',
  CANCELED: 'CANCELED'
};

exports.ENUM_CARD_ORDER_STATUS = {
  PLACED: 'PLACED',
  CANCELLED: 'CANCELLED',
  DELETED: 'DELETED',
  FAILED: 'FAILED',
  FULFILLED: 'FULFILLED'
};

exports.ENUM_CARD_ORDER_FAILED_REASON = {
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
  ACCOUNT_INACTIVE: 'ACCOUNT_INACTIVE',
  ADDRESS_UNDELIVERABLE: 'ADDRESS_UNDELIVERABLE'
};

exports.ENUM_TRANSACTION_STATUS = {
  CAPTURE: 'CAPTURE',
  REFUND: 'REFUND'
};

exports.ENUM_TRANSACTION_TYPE = {
  MONTHLY_FEE: 'MONTHLY_FEE',
  OTHER: 'OTHER'
};

exports.ENUM_TRANSACTION_FLAG = {
  FUEL_TYPE: 'FUEL_TYPE',
  TANK_CAPACITY: 'TANK_CAPACITY',
  SUSPICIOUS_FUELING: 'SUSPICIOUS_FUELING',
  FLAGGED_MERCHANT_CATEGORY: 'FLAGGED_MERCHANT_CATEGORY'
};

exports.ENUM_ACCOUNT_TAG_TYPE = {
  TRANSACTION: 'TRANSACTION',
  CARD: 'CARD',
  DRIVER: 'DRIVER',
  VEHICLE: 'VEHICLE'
};

exports.ENUM_AUTHORIZATION_STATUS = {
  PENDING: 'PENDING',
  CLOSED: 'CLOSED',
  REVERSED: 'REVERSED'
};

exports.ENUM_AUTHORIZATION_DECLINE_REASON = {
  ACCOUNT_DISABLED: 'ACCOUNT_DISABLED',
  SPENDING_CONTROLS: 'SPENDING_CONTROLS',
  EXCEED_MERCHANT_CATEGORY_PURCHASE_LIMIT_NUMBER: 'EXCEED_MERCHANT_CATEGORY_PURCHASE_LIMIT_NUMBER',
  CARD_INACTIVE: 'CARD_INACTIVE',
  CARDHOLDER_INACTIVE: 'CARDHOLDER_INACTIVE',
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
  CREDIT_LIMIT_REACHED: 'CREDIT_LIMIT_REACHED',
  CARDHOLDER_VERIFICATION_REQUIRED: 'CARDHOLDER_VERIFICATION_REQUIRED',
  NOT_ALLOWED: 'NOT_ALLOWED',
  SUSPECTED_FRAUD: 'SUSPECTED_FRAUD',
  VERIFICATION_FAILED: 'VERIFICATION_FAILED',
  OUTSIDE_OPERATIONAL_HOURS: 'OUTSIDE_OPERATIONAL_HOURS',
  TELEMATICS_SECURITY: 'TELEMATICS_SECURITY',
  RESTRICTED_MERCHANT: 'RESTRICTED_MERCHANT',
  BLOCKED_MERCHANT: 'BLOCKED_MERCHANT',
  BLOCKED_MERCHANT_STATE_ACCOUNT_LEVEL: 'BLOCKED_MERCHANT_STATE_ACCOUNT_LEVEL',
  BLOCKED_MERCHANT_STATE_CARD_LEVEL: 'BLOCKED_MERCHANT_STATE_CARD_LEVEL',
  CARD_CANCELED: 'CARD_CANCELED',
  CARD_EXPIRED: 'CARD_EXPIRED',
  CARDHOLDER_BLOCKED: 'CARDHOLDER_BLOCKED',
  INSECURE_AUTHORIZATION_METHOD: 'INSECURE_AUTHORIZATION_METHOD',
  PIN_BLOCKED: 'PIN_BLOCKED',
  AUTHORIZATION_METHOD_NOT_ALLOWED: 'AUTHORIZATION_METHOD_NOT_ALLOWED',
  GENERIC_ID_PROMPT_VERIFICATION_FAILED: 'GENERIC_ID_PROMPT_VERIFICATION_FAILED'
};

exports.ENUM_BILLING_CYCLE_STATUS = {
  SUCCEEDED: 'SUCCEEDED',
  GENERATED: 'GENERATED',
  PENDING: 'PENDING',
  FAILED: 'FAILED'
};

exports.ENUM_ENTERPRISE_PAYMENT_TERMS = {
  MONTHLY: 'MONTHLY',
  ONE_YEAR: 'ONE_YEAR',
  THREE_YEARS: 'THREE_YEARS',
  FIVE_YEARS: 'FIVE_YEARS'
};

exports.ENUM_PAYMENTHISTORY_STATUS = {
  SUCCEEDED: 'SUCCEEDED',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  GENERATED: 'GENERATED',
  DISPUTED: 'DISPUTED'
};

exports.ENUM_PAYTMENT_TYPE = {
  AUTOMATED: 'AUTOMATED',
  REPAYMENT: 'REPAYMENT',
  AUTO_RELOAD: 'AUTO_RELOAD',
  MANUAL: 'MANUAL',
  DEPOSIT: 'DEPOSIT',
  SETUP_FEE: 'SETUP_FEE',
  INVOICE: 'INVOICE',
  WIRE: 'WIRE'
};

exports.ENUM_MANUAL_PAYMENT_HISTORY_STATUS = {
  CREATED: 'CREATED',
  SUCCEEDED: 'SUCCEEDED',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
  CANCELED: 'CANCELED',
  DISPUTED: 'DISPUTED',
  REFUNDED: 'REFUNDED'
};

exports.ENUM_REFUND_PAYMENTS = {
  SUCCEEDED: 'SUCCEEDED',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED'
};

exports.ENUM_REFUND_REASON = {
  DUPLICATE: 'DUPLICATE',
  FRAUDULENT: 'FRAUDULENT',
  REQUESTEDBYCUSTOMER: 'REQUESTEDBYCUSTOMER',
  EXPIREDUNCAPTUREDCHARGE: 'EXPIREDUNCAPTUREDCHARGE',
  REQUESTED_BY_CUSTOMER: 'REQUESTED_BY_CUSTOMER'
};

exports.ENUM_DISPUTE_PAYMENTS = {
  WARNING_NEEDS_RESPONSE: 'WARNING_NEEDS_RESPONSE',
  WARNING_UNDER_REVIEW: 'WARNING_UNDER_REVIEW',
  WARNING_CLOSED: 'WARNING_CLOSED',
  NEEDS_RESPONSE: 'NEEDS_RESPONSE',
  UNDER_REVIEW: 'UNDER_REVIEW',
  CHARGE_REFUNDED: 'CHARGE_REFUNDED',
  WON: 'WON',
  LOST: 'LOST',
  CLOSED: 'CLOSED'
};

exports.ENUM_BONUS_TYPE = {
  AMAZON_GIFTCARD: 'AMAZON_GIFTCARD',
  CREDIT: 'CREDIT'
};

exports.ENUM_LENDFLOW_STATUS = {
  PENDING: 'PENDING',
  PENDING_AT_LENDFLOW: 'PENDING_AT_LENDFLOW',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

exports.ENUM_LENDFLOW_FLAG_STATUS = {
  INIT: 'INIT',
  ONHOLD: 'ONHOLD',
  RED_FLAG: 'RED_FLAG',
  COMPLETED: 'COMPLETED'
};

exports.ENUM_LENDFLOW_STATE_TYPE = {
  INIT: 'INIT',
  EKATA_MIDDESK_VERIFIED: 'EKATA_MIDDESK_VERIFIED',
  OCROLOUS_VERIFIED: 'OCROLOUS_VERIFIED',
  EXPERIAN_DNB_VERIFIED: 'EXPERIAN_DNB_VERIFIED',
  PERSONA_DOCUMENT_VERIFIED: 'PERSONA_DOCUMENT_VERIFIED'
};

exports.ENUM_UNDERWRITING_ELIGIBLE = {
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  ONHOLD: 'ONHOLD'
};

exports.ENUM_ADMIN_ROLES = {
  SUPERADMIN: 'SUPERADMIN',
  UNDERWRITER: 'UNDERWRITER',
  CUSTOMER_SUPPORT: 'CUSTOMER_SUPPORT',
  CUSTOMER_SUPPORT_MANAGER: 'CUSTOMER_SUPPORT_MANAGER',
  SALES: 'SALES',
  COLLECTIONS: 'COLLECTIONS',
  OPERATIONS: 'OPERATIONS'
};

exports.ENUM_ADMIN_PAGES = {
  DASHBOARD: 'DASHBOARD',
  APPLICATIONS: 'APPLICATIONS',
  APPLICATIONS_PENDING_DEPOSIT: 'APPLICATIONS_PENDING_DEPOSIT',
  APPROVED_CUSTOMERS: 'APPROVED_CUSTOMERS',
  CUSTOMER_INFORMATION: 'CUSTOMER_INFORMATION',
  PAYMENTS: 'PAYMENTS',
  GLOBAL_SETTINGS: 'GLOBAL_SETTINGS',
  NOTIFICATIONS: 'NOTIFICATIONS',
  BLOGS: 'BLOGS',
  RISKS: 'RISKS',
  COLLECTIONS: 'COLLECTIONS',
  SCRIPTS: 'SCRIPTS',
  DATA_ANALYSIS: 'DATA_ANALYSIS',
  ACTIVITY_LOGS: 'ACTIVITY_LOGS',
  TEAM: 'TEAM',
  ACCOUNT_SETTINGS: 'ACCOUNT_SETTINGS'
};

exports.ENUM_REFERRAL_STATUS = {
  APPLIED: 'APPLIED',
  NOT_APPLIED: 'NOT_APPLIED',
  EXPIRED: 'EXPIRED'
};

exports.ENUM_SENDGRID_TEMPLATE = {
  MARKETING_ONE: 'MARKETING_ONE',
  MARKETING_TWO: 'MARKETING_TWO',
  NOTIFICATION_ONE: 'NOTIFICATION_ONE',
  NOTIFICATION_TWO: 'NOTIFICATION_TWO',
  INTERNAL_ONE: 'INTERNAL_ONE',
  REPORT: 'REPORT',
  WHITE_PAPER_DOWNLOAD_EMAIL_TEMPLATE: 'WHITE_PAPER_DOWNLOAD_EMAIL_TEMPLATE'
};

exports.ENUM_SMS_TYPE = {
  PROSPECTIVE_LEADS_COMMUNICATION_SMS: 'PROSPECTIVE_LEADS_COMMUNICATION_SMS'
};

exports.ENUM_MAIL_TYPE = {
  EMAIL_VERIFY: 'EMAIL_VERIFY',
  PASSWORD_RESET: 'PASSWORD_RESET',
  APPROVAL_MESSAGE: 'APPROVAL_MESSAGE',
  PREFILL_NOTIFICATION: 'PREFILL_NOTIFICATION',
  REJECT_MESSAGE: 'REJECT_MESSAGE',
  REJECT_PREPAID_MESSAGE: 'REJECT_PREPAID_MESSAGE',
  PLAID_ERROR: 'PLAID_ERROR',
  SHARE_REFERRAL: 'SHARE_REFERRAL',
  ACH_FAILED: 'ACH_FAILED',
  NORMAL_STATEMENT: 'NORMAL_STATEMENT',
  LOW_BANKBALANCE_STATEMENT: 'LOW_BANKBALANCE_STATEMENT',
  LOW_ACCOUNT_BALANCE: 'LOW_ACCOUNT_BALANCE',
  DEPOSIT_MESSAGE: 'DEPOSIT_MESSAGE',
  SETUP_FEE_MESSAGE: 'SETUP_FEE_MESSAGE',
  AUTO_RELOAD_SUCCESS: 'AUTO_RELOAD_SUCCESS',
  CONTACT_US: 'CONTACT_US',
  AFFILIATE_PROGRAM: 'AFFILIATE_PROGRAM',
  PARTNERSHIPS: 'PARTNERSHIPS',
  PROMOTION_NO_FEES: 'PROMOTION_NO_FEES',
  BROKER: 'BROKER',
  SAVINGS: 'SAVINGS',
  PROSPECTIVE_LEADS_COMMUNICATION_EMAIL: 'PROSPECTIVE_LEADS_COMMUNICATION_EMAIL',
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
  TRANSACTION_FLAGGED: 'TRANSACTION_FLAGGED',
  TRANSACTION_DECLINED: 'TRANSACTION_DECLINED',
  TRANSACTION_FUEL_TYPE_NOTIFICATION: 'TRANSACTION_FUEL_TYPE_NOTIFICATION',
  TRANSACTION_APPROVED_ABOVE_AMOUNT: 'TRANSACTION_APPROVED_ABOVE_AMOUNT',
  TRANSACTION_APPROVED: 'TRANSACTION_APPROVED',
  CHILD_ACCOUNT: 'CHILD_ACCOUNT',
  DRIVER_ACCOUNT: 'DRIVER_ACCOUNT',
  ADMIN_ACCOUNT: 'ADMIN_ACCOUNT',
  EMAIL_TEST: 'EMAIL_TEST',
  ACCOUNT_ANALYSIS: 'ACCOUNT_ANALYSIS',
  ADMIN_SYSTEM_HEALTH_CHECK: 'ADMIN_SYSTEM_HEALTH_CHECK',
  NOTIFY_DELINQUENT_USERS: 'NOTIFY_DELINQUENT_USERS',
  INTERNAL_HUBSPOT: 'INTERNAL_HUBSPOT',
  ENTERPRISE_APPLICATION: 'ENTERPRISE_APPLICATION',
  WHITE_PAPER_SUBSCRIBER: 'WHITE_PAPER_SUBSCRIBER',
  CREDIT_LIMIT_THRESHOLD: 'CREDIT_LIMIT_THRESHOLD',
  NONE: 'NONE'
};

exports.ENUM_COMMENT_TYPE = {
  SUPPORT: 'SUPPORT',
  COLLECTIONS: 'COLLECTIONS',
  DEPOSIT: 'DEPOSIT'
};

exports.ENUM_ADMIN_ACTIVITY_TYPE = {
  OLDLOGS: 'OLDLOGS',
  USER_CREATE_UPDATE_INVOICE: 'USER_CREATE_UPDATE_INVOICE',
  USER_CREATE_DOCUMENT: 'USER_CREATE_DOCUMENT',
  USER_CARD_ORDER: 'USER_CARD_ORDER',
  USER_UPDATE_ACCOUNT_STATUS: 'USER_UPDATE_ACCOUNT_STATUS',
  USER_APPROVAL_PROCESS: 'USER_APPROVAL_PROCESS',
  USER_ONBOARD: 'USER_ONBOARD',
  USER_UPDATE_DEFAULT_STATUS: 'USER_UPDATE_DEFAULT_STATUS',
  USER_UPDATE_HIGHRISK_STATUS: 'USER_UPDATE_HIGHRISK_STATUS',
  USER_UPDATE_CREDIT_LIMIT: 'USER_UPDATE_CREDIT_LIMIT',
  USER_UPDATE_MAX_CARD: 'USER_UPDATE_MAX_CARD',
  USER_UPDATE_CUSTOMER_TYPE: 'USER_UPDATE_CUSTOMER_TYPE',
  USER_ADD_CREDIT_TO_ACCOUNT: 'USER_ADD_CREDIT_TO_ACCOUNT',
  USER_WAIVE_LATE_FEES: 'USER_WAIVE_LATE_FEES',
  USER_CREATE_PAYMENT_METHOD: 'USER_CREATE_PAYMENT_METHOD',
  USER_SET_PRIMRY_PAYMENT_METHOD: 'USER_SET_PRIMRY_PAYMENT_METHOD',
  USER_DELETE_PAYMENT_METHOD: 'USER_DELETE_PAYMENT_METHOD',
  USER_UPDATE_AUTO_RELOAD: 'USER_UPDATE_AUTO_RELOAD',
  USER_UPDATE_REPAYMENT: 'USER_UPDATE_REPAYMENT',
  USER_CREATE_MANUAL_PAYMENT: 'USER_CREATE_MANUAL_PAYMENT',
  USER_UPDATE_ENTERPRISE_SETTING: 'USER_UPDATE_ENTERPRISE_SETTING',
  USER_UPDATE_DETAILS: 'USER_UPDATE_DETAILS',
  USER_CREATE_PARENT_COMPANY: 'USER_CREATE_PARENT_COMPANY',
  USER_UPDATE_CARD_DETAILS: 'USER_UPDATE_CARD_DETAILS',
  USER_CANCEL_CARD: 'USER_CANCEL_CARD',
  USER_UPDATE_NOTIFICATION_SETTINGS: 'USER_UPDATE_NOTIFICATION_SETTINGS',
  USER_CONNECTED_TELEMATICS: 'USER_CONNECTED_TELEMATICS',
  USER_DISCONNECTED_TELEMATICS: 'USER_DISCONNECTED_TELEMATICS',
  USER_MAP_ELD_TO_VEHICLE: 'USER_MAP_ELD_TO_VEHICLE',
  USER_UPDATE_ACCOUNT_CONTROL_SETTINGS: 'USER_UPDATE_ACCOUNT_CONTROL_SETTINGS',
  USER_PREAUTHORIZE_TRANSACTION: 'USER_PREAUTHORIZE_TRANSACTION',
  USER_CREATE_DRIVER: 'USER_CREATE_DRIVER',
  USER_UPDATE_DRIVER: 'USER_UPDATE_DRIVER',
  USER_DELETE_DRIVER: 'USER_DELETE_DRIVER',
  USER_CREATE_VEHICLE: 'USER_CREATE_VEHICLE',
  USER_UPDATE_VEHICLE: 'USER_UPDATE_VEHICLE',
  USER_DELETE_VEHICLE: 'USER_DELETE_VEHICLE',
  USER_CREATE_POLICY: 'USER_CREATE_POLICY',
  USER_UPDATE_POLICY: 'USER_UPDATE_POLICY',
  USER_DELETE_POLICY: 'USER_DELETE_POLICY',
  USER_APPLY_POLICY: 'USER_APPLY_POLICY',
  USER_REMOVE_POLICY: 'USER_REMOVE_POLICY',
  ADMIN_TEMPORARY_INCREASE_CREDIT_LIMIT_FOR_USER: 'ADMIN_TEMPORARY_INCREASE_CREDIT_LIMIT_FOR_USER',
  ADMIN_UPDATE_SETTINGS: 'ADMIN_UPDATE_SETTINGS',
  ADMIN_PREFILL: 'ADMIN_PREFILL',
  ADMIN_IMPERSONATOR: 'ADMIN_IMPERSONATOR',
  ADMIN_UPDATE_PASSWORD: 'ADMIN_UPDATE_PASSWORD',
  ADMIN_UPDATE_FUEL_DISCOUNT: 'ADMIN_UPDATE_FUEL_DISCOUNT',
  ADMIN_UPDATE_SIGNUP_REFERRAL_BONUS: 'ADMIN_UPDATE_SIGNUP_REFERRAL_BONUS',
  ADMIN_UPDATE_MERCHANT_CATEGORIES: 'ADMIN_UPDATE_MERCHANT_CATEGORIES',
  ADMIN_CREATE: 'ADMIN_CREATE',
  ADMIN_DELETE: 'ADMIN_DELETE'
};

exports.ENUM_USER_ACTIVITY_TYPE = {
  OLDLOGS: 'OLDLOGS',
  USER_CREATE_UPDATE_INVOICE: 'USER_CREATE_UPDATE_INVOICE',
  USER_CREATE_DOCUMENT: 'USER_CREATE_DOCUMENT',
  USER_CARD_ORDER: 'USER_CARD_ORDER',
  USER_UPDATE_ACCOUNT_STATUS: 'USER_UPDATE_ACCOUNT_STATUS',
  USER_APPROVAL_PROCESS: 'USER_APPROVAL_PROCESS',
  USER_ONBOARD: 'USER_ONBOARD',
  USER_UPDATE_DEFAULT_STATUS: 'USER_UPDATE_DEFAULT_STATUS',
  USER_UPDATE_HIGHRISK_STATUS: 'USER_UPDATE_HIGHRISK_STATUS',
  USER_UPDATE_CREDIT_LIMIT: 'USER_UPDATE_CREDIT_LIMIT',
  USER_UPDATE_MAX_CARD: 'USER_UPDATE_MAX_CARD',
  USER_UPDATE_CUSTOMER_TYPE: 'USER_UPDATE_CUSTOMER_TYPE',
  USER_ADD_CREDIT_TO_ACCOUNT: 'USER_ADD_CREDIT_TO_ACCOUNT',
  USER_WAIVE_LATE_FEES: 'USER_WAIVE_LATE_FEES',
  USER_CREATE_PAYMENT_METHOD: 'USER_CREATE_PAYMENT_METHOD',
  USER_SET_PRIMRY_PAYMENT_METHOD: 'USER_SET_PRIMRY_PAYMENT_METHOD',
  USER_DELETE_PAYMENT_METHOD: 'USER_DELETE_PAYMENT_METHOD',
  USER_UPDATE_AUTO_RELOAD: 'USER_UPDATE_AUTO_RELOAD',
  USER_UPDATE_REPAYMENT: 'USER_UPDATE_REPAYMENT',
  USER_CREATE_MANUAL_PAYMENT: 'USER_CREATE_MANUAL_PAYMENT',
  USER_UPDATE_ENTERPRISE_SETTING: 'USER_UPDATE_ENTERPRISE_SETTING',
  USER_UPDATE_DETAILS: 'USER_UPDATE_DETAILS',
  USER_CREATE_PARENT_COMPANY: 'USER_CREATE_PARENT_COMPANY',
  USER_UPDATE_CARD_DETAILS: 'USER_UPDATE_CARD_DETAILS',
  USER_CANCEL_CARD: 'USER_CANCEL_CARD',
  USER_UPDATE_NOTIFICATION_SETTINGS: 'USER_UPDATE_NOTIFICATION_SETTINGS',
  USER_CONNECTED_TELEMATICS: 'USER_CONNECTED_TELEMATICS',
  USER_DISCONNECTED_TELEMATICS: 'USER_DISCONNECTED_TELEMATICS',
  USER_MAP_ELD_TO_VEHICLE: 'USER_MAP_ELD_TO_VEHICLE',
  USER_UPDATE_ACCOUNT_CONTROL_SETTINGS: 'USER_UPDATE_ACCOUNT_CONTROL_SETTINGS',
  USER_PREAUTHORIZE_TRANSACTION: 'USER_PREAUTHORIZE_TRANSACTION',
  USER_CREATE_DRIVER: 'USER_CREATE_DRIVER',
  USER_UPDATE_DRIVER: 'USER_UPDATE_DRIVER',
  USER_DELETE_DRIVER: 'USER_DELETE_DRIVER',
  USER_CREATE_VEHICLE: 'USER_CREATE_VEHICLE',
  USER_UPDATE_VEHICLE: 'USER_UPDATE_VEHICLE',
  USER_DELETE_VEHICLE: 'USER_DELETE_VEHICLE',
  USER_CREATE_POLICY: 'USER_CREATE_POLICY',
  USER_UPDATE_POLICY: 'USER_UPDATE_POLICY',
  USER_DELETE_POLICY: 'USER_DELETE_POLICY',
  USER_APPLY_POLICY: 'USER_APPLY_POLICY',
  USER_REMOVE_POLICY: 'USER_REMOVE_POLICY',
  CHILD_USER_LOG_IN: 'CHILD_USER_LOG_IN',
  PARENT_COMPANY_LOG_INTO_CHILD_COMPANY: 'PARENT_COMPANY_LOG_INTO_CHILD_COMPANY',
  USER_TRANSACTION_WEBHOOK_CALL: 'USER_TRANSACTION_WEBHOOK_CALL'
};

exports.ENUM_ELD_ORG_NAME = {
  GEOTAB: 'GEOTAB',
  SAMSARA: 'SAMSARA',
  AZUGA: 'AZUGA',
  MOTIVE: 'MOTIVE',
  UTH: 'UTH',
  FLEETUP: 'FLEETUP',
  VERIZON: 'VERIZON',
  NEXTRAQ: 'NEXTRAQ',
  BOUNCIE: 'BOUNCIE',
  FLEETR: 'FLEETR',
  LINXUP: 'LINXUP'
};

exports.ENUM_WORKFLOW_TYPE = {
  COLLECTIONS: 'COLLECTIONS',
  VERIFIED_WITHOUT_DEPOSIT: 'VERIFIED_WITHOUT_DEPOSIT',
  ONBOARD: 'ONBOARD'
};

exports.ENUM_NOTIFICATION_TYPE = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  CALL_CLIENT: 'CALL_CLIENT'
};

exports.ENUM_BUSINESS_UNDERWRITING_STAGE = {
  NOT_READY_FOR_PROCESSING: 'NOT_READY_FOR_PROCESSING',
  READY_FOR_PROCESSING: 'READY_FOR_PROCESSING',
  PROCESSING: 'PROCESSING',
  PAUSE_PROCESSING: 'PAUSE_PROCESSING',
  COMPLETED: 'COMPLETED',
  TERMINATED_PROCESSING: 'TERMINATED_PROCESSING'
};

exports.ENUM_BUSINESS_UNDERWRITING_PROCESSING_STAGE = {
  NOT_INITIALIZED: 'NOT_INITIALIZED',
  SUITABLE_APPLICATION_CHECK_COMPLETED: 'SUITABLE_APPLICATION_CHECK_COMPLETED',
  KYC_COMPLETED: 'KYC_COMPLETED',
  KYB_COMPLETED: 'KYB_COMPLETED',
  LENDFLOW_COMPLETED: 'LENDFLOW_COMPLETED',
  PERSONA_VERIFICATION_COMPLETED: 'PERSONA_VERIFICATION_COMPLETED',
  COMPLETED: 'COMPLETED'
};

exports.ENUM_BUSINESS_UNDERWRITING_ISSUES = {
  NONE: 'NONE',
  STRIPE_CAPABILITIES_INACTIVE: 'STRIPE_CAPABILITIES_INACTIVE',
  STRIPE_OBJECT_MISSING: 'STRIPE_OBJECT_MISSING',
  PLAID_TRANSACTION_MISSING: 'PLAID_TRANSACTION_MISSING',
  ROADFLEX_INTERNAL_CHECK_FAILED: 'ROADFLEX_INTERNAL_CHECK_FAILED',
  HIGHNOTE_OBJECT_MISSING: 'HIGHNOTE_OBJECT_MISSING',
  HIGHNOTE_APPLICATION_NOT_CREATED: 'HIGHNOTE_APPLICATION_NOT_CREATED',
  PERSONA_KYC_DATABASE: 'PERSONA_KYC_DATABASE',
  PERSONA_KYC_WATCHLIST: 'PERSONA_KYC_WATCHLIST',
  SYSTEM_ERROR: 'SYSTEM_ERROR'
};

exports.BUSINESS_UNDERWRITING_DATA_TYPE_ENUM = {
  VALIDATION: 'VALIDATION',
  PERSONA_KYC: 'PERSONA_KYC',
  PERSONA_KYB: 'PERSONA_KYB',
  EXPERIAN_KYB: 'EXPERIAN_KYB',
  LENDFLOW_DATA: 'LENDFLOW_DATA',
  LENDFLOW_OLD_DATA: 'LENDFLOW_OLD_DATA',
  PERSONA_VERIFICATION: 'PERSONA_VERIFICATION',
  BASIC_INFORMATION: 'BASIC_INFORMATION',
  HIGHNOTE: 'HIGHNOTE'
};

exports.BUSINESS_UNDERWRITING_SUB_DATA_TYPE_ENUM = {
  PERSONA_KYC_GOVT_ID: 'PERSONA_KYC_GOVT_ID',
  PERSONA_KYC_DATABASE_VERIFICAITON: 'PERSONA_KYC_DATABASE_VERIFICAITON',
  PRESONA_KYC_WATCHLIST: 'PRESONA_KYC_WATCHLIST',
  PERSONA_KYB_TIN_MATCH: 'PERSONA_KYB_TIN_MATCH',
  PERSONA_KYB_BUSINESS_LOOKUP: 'PERSONA_KYB_BUSINESS_LOOKUP',
  PERSONA_KYB_BUSINESS_WATCHLIST: 'PERSONA_KYB_BUSINESS_WATCHLIST',
  LENDFLOW_PRODUCTS: 'LENDFLOW_PRODUCTS',
  SUITABLE_APPLICATION_VALIDATION: 'SUITABLE_APPLICATION_VALIDATION',
  PERSONA_VERIFICATION_EMAIL: 'PERSONA_VERIFICATION_EMAIL',
  PERSONA_VERIFICATION_PHONE: 'PERSONA_VERIFICATION_PHONE',
  BASIC_INFORMATION: 'BASIC_INFORMATION',
  HIGHNOTE_ACCOUNT: 'HIGHNOTE_ACCOUNT',
  HIGHNOTE_APPLICATION: 'HIGHNOTE_APPLICATION'
};

exports.BUSINESS_UNDERWRITING_DATA_STATUS_ENUM = {
  INIT: 'INIT',
  PENDING: 'PENDING',
  ONHOLD: 'ONHOLD',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
};

exports.ENUM_UNDERWRITING_RESULT_ELIGIBLE = {
  INIT: 'INIT',
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  ONHOLD: 'ONHOLD'
};

exports.ENUM_LEDGER_NAME = {
  CASH: 'CASH',
  ACCOUNTS_RECEIVABLE: 'ACCOUNTS_RECEIVABLE'
};

exports.ENUM_LEDGER_TRANSACTION_STATUS = {
  PENDING: 'PENDING',
  POSTED: 'POSTED',
  ARCHIVED: 'ARCHIVED'
};

exports.ENUM_SYSTEM_HEALTH_TYPE = {
  CRON: 'CRON',
  VALIDATION_SCRIPT: 'VALIDATION_SCRIPT',
  OTHER: 'OTHER',
  DISCREPANCY: 'DISCREPANCY'
};

exports.ENUM_REPAYMENT_STATUS = {
  INIT: 'INIT',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED'
};

exports.ENUM_REPAYMENT_DURATION_TYPE = {
  MONTHLY: 'MONTHLY',
  WEEKLY: 'WEEKLY'
};

exports.ENUM_LOG_FILE_TYPE = {
  USER_LOG_FILE: 'USER_LOG_FILE',
  ADMIN_LOG_FILE: 'ADMIN_LOG_FILE',
  EMAIL_HISTORY_LOG_FILE: 'EMAIL_HISTORY_LOG_FILE',
  EVENTS_LOG_FILE: 'EVENTS_LOG_FILE'
};

exports.ENUM_LATE_FEES_TYPE = {
  CAPTURE_ONE: 'CAPTURE_ONE',
  CAPTURE_TWO: 'CAPTURE_TWO',
  WAIVE: 'WAIVE'
};

exports.ENUM_STRIPE_DETAIL_STATUS = {
  INIT: 'INIT',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS'
};

exports.ENUM_AUTO_RELOAD_TYPE = {
  ON_SCH: 'ON_SCH',
  ON_BAL: 'ON_BAL'
};

exports.ENUM_AUTO_RELOAD_FREQUENCY = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY'
};

exports.ENUM_METRIC_NAMES = {
  GROSS_MERCHANDISE_VALUE: 'GROSS_MERCHANDISE_VALUE',
  TOTAL_TRANSACTIONS: 'TOTAL_TRANSACTIONS',
  TOTAL_OUTSTANDING_BALANCE: 'TOTAL_OUTSTANDING_BALANCE',
  TOTAL_OUTSTANDING_LATE_FEE: 'TOTAL_OUTSTANDING_LATE_FEE',
  TOTAL_USERS: 'TOTAL_USERS',
  TOTAL_ACTIVE_USERS: 'TOTAL_ACTIVE_USERS',
  TOTAL_CARDS: 'TOTAL_CARDS',
  TOTAL_ACTIVE_CARDS: 'TOTAL_ACTIVE_CARDS',
  LATEST_BILLING_CYCLE_OUTSTANDING_BALANCE: 'LATEST_BILLING_CYCLE_OUTSTANDING_BALANCE',
  TOTAL_AUTORELOAD_USERS: 'TOTAL_AUTORELOAD_USERS',
  TOTAL_REPAYMENT_USERS: 'TOTAL_REPAYMENT_USERS',
  AMOUNT_COLLECTED_FROM_REPAYMENT_USERS: 'AMOUNT_COLLECTED_FROM_REPAYMENT_USERS',
  TOTAL_CREDIT_USERS: 'TOTAL_CREDIT_USERS',
  TOTAL_ACTIVE_CREDIT_USERS: 'TOTAL_ACTIVE_CREDIT_USERS',
  TOTAL_CREDIT_PLUS_USERS: 'TOTAL_CREDIT_PLUS_USERS',
  TOTAL_ACTIVE_CREDIT_PLUS_USERS: 'TOTAL_ACTIVE_CREDIT_PLUS_USERS',
  TOTAL_PREPAID_USERS: 'TOTAL_PREPAID_USERS',
  TOTAL_ACTIVE_PREPAID_USERS: 'TOTAL_ACTIVE_PREPAID_USERS',
  TOTAL_PREPAID_PLUS_USERS: 'TOTAL_PREPAID_PLUS_USERS',
  TOTAL_ACTIVE_PREPAID_PLUS_USERS: 'TOTAL_ACTIVE_PREPAID_PLUS_USERS',
  TOTAL_CREDIT_ENTERPRISE_USERS: 'TOTAL_CREDIT_ENTERPRISE_USERS',
  TOTAL_ACTIVE_CREDIT_ENTERPRISE_USERS: 'TOTAL_ACTIVE_CREDIT_ENTERPRISE_USERS',
  TOTAL_PREPAID_ENTERPRISE_USERS: 'TOTAL_PREPAID_ENTERPRISE_USERS',
  TOTAL_ACTIVE_PREPAID_ENTERPRISE_USERS: 'TOTAL_ACTIVE_PREPAID_ENTERPRISE_USERS',
  TOTAL_WALLET_BALANCE_FOR_CREDIT_USERS: 'TOTAL_WALLET_BALANCE_FOR_CREDIT_USERS',
  TOTAL_WALLET_BALANCE_FOR_CREDIT_PLUS_USERS: 'TOTAL_WALLET_BALANCE_FOR_CREDIT_PLUS_USERS',
  TOTAL_WALLET_BALANCE_FOR_PREPAID_USERS: 'TOTAL_WALLET_BALANCE_FOR_PREPAID_USERS',
  TOTAL_WALLET_BALANCE_FOR_PREPAID_PLUS_USERS: 'TOTAL_WALLET_BALANCE_FOR_PREPAID_PLUS_USERS',
  TOTAL_WALLET_BALANCE_FOR_CREDIT_ENTERPRISE_USERS: 'TOTAL_WALLET_BALANCE_FOR_CREDIT_ENTERPRISE_USERS',
  TOTAL_WALLET_BALANCE_FOR_PREPAID_ENTERPRISE_USERS: 'TOTAL_WALLET_BALANCE_FOR_PREPAID_ENTERPRISE_USERS'
};

exports.ENUM_METRIC_UNITS = {
  UNIT: 'UNIT',
  CENTS: 'CENTS'
};

exports.ENUM_METRIC_TYPES = {
  STATISTICS: 'STATISTICS',
  CUSTOMER_INFO: 'CUSTOMER_INFO'
};

exports.ENUM_PROSPECTIVE_LEAD_ACTION_TYPE = {
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  EMAIL_AND_SMS: 'EMAIL_AND_SMS'
};

exports.ENUM_EXECUTION_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED'
};

exports.ENUM_CUSTOMER_SOURCE = {
  FACEBOOK: 'FACEBOOK',
  GOOGLE_SEARCH: 'GOOGLE_SEARCH',
  MAGAZINE: 'MAGAZINE',
  REFERRAL: 'REFERRAL',
  CONFERENCE: 'CONFERENCE',
  OTHERS: 'OTHERS',
  FLEETUP: 'FLEETUP',
  NALP: 'NALP',
  NPMA: 'NPMA',
  ADVANTAGEONE: 'ADVANTAGEONE',
  LINXUP: 'LINXUP',
  PROMILES: 'PROMILES',
  PHCC: 'PHCC',
  GEOTABCONNECT: 'GEOTABCONNECT',
  DISCOUNTTIRE: 'DISCOUNTTIRE',
  KONEXIAL: 'KONEXIAL',
  EVERLINE: 'EVERLINE',
  FLEETSHARP: 'FLEETSHARP',
  EJWARD: 'EJWARD',
  UNKNOWN: 'UNKNOWN'
};

exports.ENUM_NOTIFICATION_NAME = {
  STATEMENT_AVAILABLE: 'STATEMENT_AVAILABLE',
  CREDIT_LIMIT_THRESHOLD: 'CREDIT_LIMIT_THRESHOLD',
  TRANSACTION_DECLINED: 'TRANSACTION_DECLINED',
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
  TRANSACTION_FLAGGED: 'TRANSACTION_FLAGGED',
  LOW_BALANCE: 'LOW_BALANCE',
  ANALYSIS_WEEKLY: 'ANALYSIS_WEEKLY',
  ANALYSIS_DAILY: 'ANALYSIS_DAILY',
  TRANSACTION_ABOVE_AMOUNT: 'TRANSACTION_ABOVE_AMOUNT',
  TRANSACTION_FUEL_TYPE: 'TRANSACTION_FUEL_TYPE',
  TRANSACTION_APPROVED: 'TRANSACTION_APPROVED'
};

exports.ENUM_NOTIFICATION_CATEGORY = {
  BILLING_AND_PAYMENT: 'BILLING_AND_PAYMENT',
  TRANSACTION: 'TRANSACTION',
  ACCOUNT: 'ACCOUNT',
  ANALYSIS: 'ANALYSIS'
};

exports.ENUM_NOTIFICATION_CHANNEL = {
  NONE: 'NONE',
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  EMAIL_AND_SMS: 'EMAIL_AND_SMS'
};

exports.ENUM_PROMOTION_TYPE = {
  MONTHLY_FEE: 'MONTHLY_FEE',
  NO_COST_FEE: 'NO_COST_FEE'
};

exports.ENUM_EVENT_SOURCE = {
  STRIPE: 'STRIPE',
  HIGHNOTE: 'HIGHNOTE'
};

exports.ENUM_SUBSCRIBER_SOURCE = {
  MAIN_LANDING_PAGE: 'MAIN_LANDING_PAGE',
  WHITE_PAPER: 'WHITE_PAPER'
};

exports.ENUM_FEATURE_TYPE = {
  FUEL_STATION_FINDER: 'FUEL_STATION_FINDER'
};

exports.Prisma.ModelName = {
  Role: 'Role',
  UserProfileRole: 'UserProfileRole',
  SuperUserRole: 'SuperUserRole',
  SuperUserProfileRole: 'SuperUserProfileRole',
  Permission: 'Permission',
  Resolver: 'Resolver',
  PermissionResolver: 'PermissionResolver',
  Feature: 'Feature',
  UserProfileFeature: 'UserProfileFeature',
  UserProfileResolver: 'UserProfileResolver',
  PermissionFeature: 'PermissionFeature',
  AdditionalUserDetail: 'AdditionalUserDetail',
  UserProfile: 'UserProfile',
  UserTransactionsFileExportTemplate: 'UserTransactionsFileExportTemplate',
  AccountDisplaySetting: 'AccountDisplaySetting',
  AzureExternalUserInvitation: 'AzureExternalUserInvitation',
  AccountControlSettings: 'AccountControlSettings',
  ParameterFilter: 'ParameterFilter',
  OtherUserDetail: 'OtherUserDetail',
  Products: 'Products',
  Alerts: 'Alerts',
  PreauthorizeTransactionAlerts: 'PreauthorizeTransactionAlerts',
  DriverAlerts: 'DriverAlerts',
  UserProductStatus: 'UserProductStatus',
  QuickBooksDetail: 'QuickBooksDetail',
  AddressUsage: 'AddressUsage',
  Business: 'Business',
  CardPaymentMethod: 'CardPaymentMethod',
  FleetInfo: 'FleetInfo',
  AccountDocuments: 'AccountDocuments',
  StatementCustomizationSetting: 'StatementCustomizationSetting',
  FactorDocument: 'FactorDocument',
  PlaidConnect: 'PlaidConnect',
  PlaidConnectPending: 'PlaidConnectPending',
  UserWallet: 'UserWallet',
  UserWalletItems: 'UserWalletItems',
  DefaultSetting: 'DefaultSetting',
  CardHoldersMembership: 'CardHoldersMembership',
  CronInfo: 'CronInfo',
  Card: 'Card',
  CardMerchants: 'CardMerchants',
  OperationalHours: 'OperationalHours',
  CardRule: 'CardRule',
  FleetDriver: 'FleetDriver',
  Fleet: 'Fleet',
  FleetOdometerReading: 'FleetOdometerReading',
  CardHolderSpending: 'CardHolderSpending',
  CardReplacement: 'CardReplacement',
  CardSpending: 'CardSpending',
  CardShipping: 'CardShipping',
  CardOrder: 'CardOrder',
  Transaction: 'Transaction',
  AccountTag: 'AccountTag',
  CardAccountTag: 'CardAccountTag',
  FleetAccountTag: 'FleetAccountTag',
  FleetDriverAccountTag: 'FleetDriverAccountTag',
  TransactionAccountTag: 'TransactionAccountTag',
  OldTransactionAccountTag: 'OldTransactionAccountTag',
  AuthorizationAccountTag: 'AuthorizationAccountTag',
  OldTransaction: 'OldTransaction',
  ImportedTransaction: 'ImportedTransaction',
  TransactionReceipt: 'TransactionReceipt',
  OldTransactionReceipt: 'OldTransactionReceipt',
  Authorization: 'Authorization',
  BillingCycle: 'BillingCycle',
  BillingCycleItems: 'BillingCycleItems',
  PaymentHistory: 'PaymentHistory',
  ManualPaymentHistory: 'ManualPaymentHistory',
  RefundPayments: 'RefundPayments',
  DisputePayments: 'DisputePayments',
  UserSignUpBonus: 'UserSignUpBonus',
  UserLendFlowData: 'UserLendFlowData',
  UnderwritingData: 'UnderwritingData',
  AdminUnderwritingSetting: 'AdminUnderwritingSetting',
  Admin: 'Admin',
  AdminRole: 'AdminRole',
  AdminRoleMaster: 'AdminRoleMaster',
  AdminPermission: 'AdminPermission',
  AdminPermissionRoleMaster: 'AdminPermissionRoleMaster',
  Session: 'Session',
  AdminFuelDiscount: 'AdminFuelDiscount',
  AdminSignUpBonus: 'AdminSignUpBonus',
  AdminReferralBonus: 'AdminReferralBonus',
  Referral: 'Referral',
  ReferralCode: 'ReferralCode',
  ReferralCredit: 'ReferralCredit',
  AffiliateReferral: 'AffiliateReferral',
  AdminEmail: 'AdminEmail',
  EmailTemplates: 'EmailTemplates',
  SendGridTemplates: 'SendGridTemplates',
  SmsTemplates: 'SmsTemplates',
  MailType: 'MailType',
  AdminCollectionsWorkflowSettings: 'AdminCollectionsWorkflowSettings',
  AdminBlogs: 'AdminBlogs',
  AdminBlogImages: 'AdminBlogImages',
  AdminInTheNews: 'AdminInTheNews',
  AdminCardSetting: 'AdminCardSetting',
  AdminApprovalSetting: 'AdminApprovalSetting',
  ApproveAutoUnderwritingSetting: 'ApproveAutoUnderwritingSetting',
  RejectUnderwritingSetting: 'RejectUnderwritingSetting',
  AdminComments: 'AdminComments',
  AdminActivityLog: 'AdminActivityLog',
  UserActivityLog: 'UserActivityLog',
  LendflowProductSchema: 'LendflowProductSchema',
  EldDeviceInfo: 'EldDeviceInfo',
  EldDeviceDetails: 'EldDeviceDetails',
  EldDeviceMappingHistory: 'EldDeviceMappingHistory',
  EmailWorkflow: 'EmailWorkflow',
  BusinessUnderwritingProcess: 'BusinessUnderwritingProcess',
  BusinessUnderwritingData: 'BusinessUnderwritingData',
  UnderwritingDataResult: 'UnderwritingDataResult',
  Ledger: 'Ledger',
  LedgerTransaction: 'LedgerTransaction',
  LedgerEntries: 'LedgerEntries',
  AdminSystemHealth: 'AdminSystemHealth',
  UserFunctionalityTrackerByAdmin: 'UserFunctionalityTrackerByAdmin',
  Repayment: 'Repayment',
  EmailHistory: 'EmailHistory',
  LogFiles: 'LogFiles',
  LateFeesTransaction: 'LateFeesTransaction',
  MonthlyCardFee: 'MonthlyCardFee',
  StripeDetails: 'StripeDetails',
  AutoReloadSetting: 'AutoReloadSetting',
  Fleetio: 'Fleetio',
  FleetioFuelEntry: 'FleetioFuelEntry',
  MetricCapture: 'MetricCapture',
  AdminProspectiveLeadsFile: 'AdminProspectiveLeadsFile',
  AdminProspectiveLeadsCommunicationFile: 'AdminProspectiveLeadsCommunicationFile',
  SalesPipeLine: 'SalesPipeLine',
  UserLead: 'UserLead',
  UserNotification: 'UserNotification',
  Promotion: 'Promotion',
  UserDevice: 'UserDevice',
  MonthlyClosingBalance: 'MonthlyClosingBalance',
  FileChecksum: 'FileChecksum',
  Events: 'Events',
  HighNoteDocumentUpload: 'HighNoteDocumentUpload',
  LandingPageSubscriberList: 'LandingPageSubscriberList',
  EJWard: 'EJWard',
  ApiUsage: 'ApiUsage'
};

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
